export const xaosPresets = [
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Andromeda",
    "alpha": 305,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 377,
    "gamma": -3
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.03703703703703703,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 47
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 168,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": 2
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 126,
    "gamma": 630
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 5,
    "gamma": -2
  },
  {
    "pattern": "Lyra",
    "alpha": 1024,
    "beta": 128,
    "gamma": 128
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 313,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 612
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 714
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 175,
    "beta": 111,
    "gamma": 369
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 583,
    "gamma": 820
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 144,
    "gamma": -8
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 168,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Sagitta",
    "alpha": -3,
    "beta": 55,
    "gamma": -8
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 2.700000000000001
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 197,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 15
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 15,
    "beta": 3,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 369,
    "beta": 111,
    "gamma": 369
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 724
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 854
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 17
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 0.2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.03125,
    "gamma": 0.0625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 126,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 532,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.5,
    "gamma": 0.5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 34,
    "beta": 5,
    "gamma": 55
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 39
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 27
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.25,
    "gamma": 0.0078125
  },
  {
    "pattern": "Sculptor",
    "alpha": 368,
    "beta": 110,
    "gamma": 174
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 3,
    "gamma": -13
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 43
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 126,
    "beta": 6,
    "gamma": 270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 841
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Pisces",
    "alpha": 2.667,
    "beta": 2.667,
    "gamma": 50.59318992632099
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 5,
    "gamma": 5
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 2,
    "beta": 89,
    "gamma": -21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.5,
    "gamma": 0.03125
  },
  {
    "pattern": "Scorpius",
    "alpha": 2,
    "beta": 5,
    "gamma": 52
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 647
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 286,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Crux",
    "alpha": 1026,
    "beta": 168,
    "gamma": 546
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -8,
    "beta": 233,
    "gamma": 8
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 33
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 13,
    "beta": 144,
    "gamma": -55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 859
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 175,
    "beta": 15,
    "gamma": 260
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Aquarius",
    "alpha": -3,
    "beta": 5,
    "gamma": -21
  },
  {
    "pattern": "Scorpius",
    "alpha": 5.0625,
    "beta": 5.0625,
    "gamma": 17.0859375
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 169,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 708
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 4.5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 60,
    "gamma": 330
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 61
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Sagitta",
    "alpha": -2,
    "beta": 89,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 60,
    "gamma": 396
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 0,
    "beta": 155,
    "gamma": 0
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.5,
    "gamma": 0.03125
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 2,
    "beta": 1,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 808,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.5,
    "gamma": 0.125
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 818,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 844
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 226,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 25,
    "beta": 4,
    "gamma": 100
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 18,
    "gamma": 168
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.0001524157902758725,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Draco",
    "alpha": 9,
    "beta": 4,
    "gamma": 441
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 66,
    "beta": 6,
    "gamma": 91
  },
  {
    "pattern": "Draco",
    "alpha": 18,
    "beta": 6,
    "gamma": 486
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 34,
    "gamma": 55
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 215,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 546,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 666
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 21,
    "beta": 3,
    "gamma": 36
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 3,
    "gamma": -5
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.03703703703703703,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 34,
    "gamma": -13
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 205,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 23
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -13,
    "beta": 233,
    "gamma": 13
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 284,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 17
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 2,
    "gamma": 32
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 39,
    "gamma": 41
  },
  {
    "pattern": "Andromeda",
    "alpha": 168,
    "beta": 126,
    "gamma": 396
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 155,
    "beta": 14,
    "gamma": 399
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 41,
    "gamma": 47
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -21,
    "beta": 233,
    "gamma": 2
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 53
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 212,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 60,
    "gamma": 396
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 61
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 47
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 518,
    "gamma": 819
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.3333333333333333,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 330,
    "gamma": 630
  },
  {
    "pattern": "Andromeda",
    "alpha": 293,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.5,
    "gamma": 0.015625
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 36,
    "gamma": 396
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 89,
    "gamma": 89
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 688
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 0.4
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 128,
    "beta": 64,
    "gamma": 512
  },
  {
    "pattern": "Sculptor",
    "alpha": 371,
    "beta": 111,
    "gamma": 175
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 36,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 528,
    "gamma": 819
  },
  {
    "pattern": "Sagitta",
    "alpha": -13,
    "beta": 144,
    "gamma": -13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.25,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.3333333333333333,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 51
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 814,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 0.7999999999999999
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.4999999999999999,
    "beta": 0.5000000000000001,
    "gamma": 1.4997597826618576
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 29
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 43
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 8.899999999999984
  },
  {
    "pattern": "Auriga",
    "alpha": 3,
    "beta": 3,
    "gamma": 15
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 818,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 813,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -610
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 322,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Andromeda",
    "alpha": 396,
    "beta": 270,
    "gamma": 630
  },
  {
    "pattern": "Pisces",
    "alpha": -8,
    "beta": 13,
    "gamma": 21
  },
  {
    "pattern": "Crux",
    "alpha": 1026,
    "beta": 630,
    "gamma": 720
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.125,
    "gamma": 0.03125
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 248,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 202,
    "gamma": 610
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -2,
    "beta": 144,
    "gamma": 13
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 35
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 512,
    "beta": 256,
    "gamma": 512
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 505,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.5,
    "gamma": 0.125
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 306,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 1597,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 683
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 33
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 610,
    "beta": 144,
    "gamma": 610
  },
  {
    "pattern": "Scorpius",
    "alpha": 12.945889943987908,
    "beta": 4.31529664799597,
    "gamma": 17.26118659198388
  },
  {
    "pattern": "Pisces",
    "alpha": -34,
    "beta": 2,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.5,
    "gamma": 0.015625
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 717
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 33
  },
  {
    "pattern": "Crux",
    "alpha": 1059,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 45
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 59
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 100,
    "beta": 20,
    "gamma": 300
  },
  {
    "pattern": "Lyra",
    "alpha": 1126,
    "beta": 142,
    "gamma": 73
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 67
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 60,
    "gamma": 630
  },
  {
    "pattern": "Lyra",
    "alpha": 987,
    "beta": 89,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 53
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 610,
    "gamma": 3
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 2,
    "beta": 144,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 809,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Andromeda",
    "alpha": 318,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 820,
    "beta": 118,
    "gamma": 584
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 59
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 300,
    "beta": 3,
    "gamma": 300
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 513,
    "gamma": 819
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 1597,
    "gamma": 2
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 635
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.015625,
    "gamma": 0.03125
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 270,
    "gamma": 546
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 89,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 519,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 168,
    "gamma": 546
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 359.8637441018393,
    "beta": 2.667,
    "gamma": 359.8637441018393
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 377,
    "gamma": 3
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 51
  },
  {
    "pattern": "Pisces",
    "alpha": 5,
    "beta": 2,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Auriga",
    "alpha": 2,
    "beta": 55,
    "gamma": -89
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 677
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 8,
    "beta": 377,
    "gamma": -34
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 59
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Pisces",
    "alpha": 25,
    "beta": 16,
    "gamma": 144
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 169,
    "beta": 9,
    "gamma": 441
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 148.4131591025766,
    "beta": 20.085536923187668,
    "gamma": 403.4287934927351
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 8,
    "beta": 89,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 889,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 126,
    "beta": 6,
    "gamma": 396
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 168,
    "gamma": 630
  },
  {
    "pattern": "Sagitta",
    "alpha": -2,
    "beta": 144,
    "gamma": 34
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 6,
    "gamma": 216
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 29
  },
  {
    "pattern": "Pisces",
    "alpha": -34,
    "beta": 2,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 23
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 805,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Sagitta",
    "alpha": -8,
    "beta": 89,
    "gamma": 21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.125,
    "gamma": 0.5
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 225,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 61
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 664
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 45
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 330,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 521,
    "gamma": 819
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 276,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": 2.25,
    "beta": 1.5,
    "gamma": 17.0859375
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 120,
    "beta": 15,
    "gamma": 153
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 229,
    "gamma": 610
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 649
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 3,
    "beta": 610,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 842
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 45
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 36,
    "beta": 6,
    "gamma": 45
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 59
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 54.598150033144236,
    "beta": 7.38905609893065,
    "gamma": 403.4287934927351
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 34,
    "gamma": -55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Libra",
    "alpha": 39,
    "beta": 0,
    "gamma": 399
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20.085536923187668,
    "beta": 2.718281828459045,
    "gamma": 54.598150033144236
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 66,
    "beta": 15,
    "gamma": 120
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 17
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.125,
    "gamma": 0.5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 625,
    "beta": 125,
    "gamma": 625
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 987,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Pisces",
    "alpha": 6,
    "beta": 6,
    "gamma": 54
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 66,
    "beta": 7,
    "gamma": 214.49999999999997
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 17
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 51
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.012345679012345677,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Lyra",
    "alpha": 1026,
    "beta": 126,
    "gamma": 90
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 61
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 15
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 11
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 2.600000000000001
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 55,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Auriga",
    "alpha": -13,
    "beta": 55,
    "gamma": 34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.125,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 39
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 33
  },
  {
    "pattern": "Sculptor",
    "alpha": 368,
    "beta": 107,
    "gamma": 175
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 15
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 168,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 813,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 818,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Andromeda",
    "alpha": 270,
    "beta": 216,
    "gamma": 630
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 60,
    "gamma": 330
  },
  {
    "pattern": "Pisces",
    "alpha": 3,
    "beta": 3,
    "gamma": 34
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 50.59318992632099,
    "beta": 7.112888999999999,
    "gamma": 134.93203753349806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 125,
    "beta": 27,
    "gamma": 512
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.0625,
    "gamma": 0.5
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 39
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": -21
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 618
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 155,
    "beta": 39,
    "gamma": 155
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 222,
    "gamma": 610
  },
  {
    "pattern": "Andromeda",
    "alpha": 90,
    "beta": 90,
    "gamma": 396
  },
  {
    "pattern": "Sculptor",
    "alpha": 0,
    "beta": 1,
    "gamma": 1.4997597826618576
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.25,
    "gamma": 0.25
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 1597,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 852
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 168,
    "gamma": 630
  },
  {
    "pattern": "Pisces",
    "alpha": 16,
    "beta": 9,
    "gamma": 121
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 536,
    "gamma": 819
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 716
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 126,
    "gamma": 60
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 168,
    "gamma": 168
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 814,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 25,
    "beta": 4,
    "gamma": 196
  },
  {
    "pattern": "Draco",
    "alpha": 16,
    "beta": 4,
    "gamma": 512
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 856
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20.999999999999996,
    "beta": 2.5,
    "gamma": 66
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 816,
    "beta": 90,
    "gamma": 630
  },
  {
    "pattern": "Lyra",
    "alpha": 1458,
    "beta": 162,
    "gamma": 6
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 583,
    "beta": 118,
    "gamma": 585
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 49
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.25,
    "beta": 0.5,
    "gamma": 0.125
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.1111111111111111,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.012345679012345677,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 253,
    "gamma": 610
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.001371742112482853,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 89,
    "gamma": 8
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 16,
    "beta": 2,
    "gamma": 32
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 28,
    "beta": 6,
    "gamma": 91
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 89,
    "gamma": 2
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 57
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 15
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 34,
    "gamma": 3
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 270,
    "beta": 6,
    "gamma": 396
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 169,
    "beta": 25,
    "gamma": 169
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Andromeda",
    "alpha": 126,
    "beta": 90,
    "gamma": 330
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 90,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": -144
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 3,
    "beta": 610,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 32,
    "beta": 4,
    "gamma": 256
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 25
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 610,
    "gamma": -5
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 292,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 852
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.3333333333333333,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Auriga",
    "alpha": -13,
    "beta": 13,
    "gamma": -3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 585,
    "beta": 118,
    "gamma": 585
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 511,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 60,
    "gamma": 270
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 2,
    "gamma": 29
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Pisces",
    "alpha": -5,
    "beta": 3,
    "gamma": -34
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 6,
    "gamma": 546
  },
  {
    "pattern": "Sagitta",
    "alpha": -13,
    "beta": 144,
    "gamma": -3
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.012345679012345677,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 258,
    "beta": 155,
    "gamma": 399
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.00390625,
    "beta": 0.015625,
    "gamma": 0.25
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 175,
    "beta": 34,
    "gamma": 369
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 855
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 848
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 47
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 15
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 39,
    "gamma": 43
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 19
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Crux",
    "alpha": 720,
    "beta": 330,
    "gamma": 546
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 65,
    "beta": 15,
    "gamma": 175
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 21,
    "gamma": -34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.5,
    "gamma": 0.5
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.4999999999999999,
    "beta": 0.5000000000000002,
    "gamma": 0
  },
  {
    "pattern": "Big Dipper",
    "alpha": -13,
    "beta": 2,
    "gamma": -13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.25,
    "gamma": 0.25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 55
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 126,
    "gamma": 630
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 264,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 16,
    "beta": 4,
    "gamma": 36
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 39,
    "gamma": 39
  },
  {
    "pattern": "Lyra",
    "alpha": 1140,
    "beta": 90,
    "gamma": 468
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 60,
    "beta": 6,
    "gamma": 330
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 29
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.012345679012345677,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 27
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 128,
    "beta": 16,
    "gamma": 128
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 55,
    "gamma": -89
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.1111111111111111,
    "beta": 0.03703703703703703,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 8,
    "beta": 2,
    "gamma": 55
  },
  {
    "pattern": "Crux",
    "alpha": 1051,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 39,
    "gamma": 35
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 441,
    "beta": 9,
    "gamma": 441
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 5,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 49
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Crux",
    "alpha": 819,
    "beta": 118,
    "gamma": 583
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -8,
    "beta": 233,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 22,
    "beta": 2,
    "gamma": 29
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.125,
    "gamma": 0.015625
  },
  {
    "pattern": "Auriga",
    "alpha": -8,
    "beta": 13,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 682
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 583,
    "gamma": 819
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -3,
    "beta": 144,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 13
  },
  {
    "pattern": "Leo",
    "alpha": 13,
    "beta": 2,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 887,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 805,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 168,
    "beta": 6,
    "gamma": 330
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 25
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 693
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Andromeda",
    "alpha": 297,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 565,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 857
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 43
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 90,
    "gamma": 468
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 173
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 260,
    "beta": 15,
    "gamma": 369
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 144,
    "gamma": -144
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 89,
    "gamma": 89
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 816,
    "beta": 396,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 35
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 224,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 817,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Scorpius",
    "alpha": 2,
    "beta": 5,
    "gamma": 56
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 3,
    "gamma": 2
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.0625,
    "gamma": 0.03125
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 987,
    "gamma": -3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 36,
    "gamma": 330
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.03125,
    "gamma": 0.25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Andromeda",
    "alpha": 546,
    "beta": 330,
    "gamma": 720
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 21,
    "gamma": 8
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 5,
    "gamma": 58
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 22,
    "beta": 4,
    "gamma": 37
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 701
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.00045724737082761756,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 3,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 619
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 820,
    "beta": 118,
    "gamma": 583
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 47
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 144,
    "gamma": -21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 65,
    "gamma": 21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 55
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 816,
    "beta": 330,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 812,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 5,
    "gamma": 3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 256,
    "beta": 128,
    "gamma": 512
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": -34
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0,
    "beta": 2.1972245773362196,
    "gamma": 0
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -8,
    "beta": 144,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 55,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 3,
    "beta": 1597,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 161
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 892,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": -5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.5,
    "gamma": 0.00390625
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 125,
    "beta": 8,
    "gamma": 512
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 177,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Leo",
    "alpha": 13,
    "beta": 2,
    "gamma": 55
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.5,
    "gamma": 0.015625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 3,
    "gamma": 3
  },
  {
    "pattern": "Aquarius",
    "alpha": 0,
    "beta": 3.2188758248682006,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 155
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 18
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 69
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 5,
    "beta": 1597,
    "gamma": -21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 260,
    "beta": 65,
    "gamma": 260
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 2,
    "beta": 55,
    "gamma": -8
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 13,
    "beta": 233,
    "gamma": -55
  },
  {
    "pattern": "Leo",
    "alpha": 2,
    "beta": 1,
    "gamma": 47
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Leo",
    "alpha": 31.006276680299816,
    "beta": 3.141592653589793,
    "gamma": 97.40909103400242
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": -8
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.5000000000000001,
    "gamma": 0.5000000000000001
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 43
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 3,
    "beta": 144,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.4999999999999999,
    "beta": 0.5000000000000001,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.00045724737082761756,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 238,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 163
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 25,
    "beta": 4,
    "gamma": 64
  },
  {
    "pattern": "Crux",
    "alpha": 1099,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.25,
    "gamma": 0.00390625
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 60,
    "gamma": 270
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 41
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 37
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 43
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 9.899999999999993
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 60,
    "gamma": 546
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 63
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 214,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 845
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 168,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 89,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 81,
    "beta": 9,
    "gamma": 243
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 159
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.03703703703703703,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 13,
    "beta": 3,
    "gamma": 34
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 65,
    "beta": 5,
    "gamma": 111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 41,
    "gamma": 33
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -13,
    "beta": 233,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 34,
    "beta": 377,
    "gamma": -144
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 15
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 61
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 91,
    "beta": 6,
    "gamma": 120
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 987,
    "gamma": 8
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 3,
    "beta": 233,
    "gamma": -21
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -8,
    "beta": 233,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 3,
    "gamma": 2
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 377,
    "gamma": -89
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 39,
    "gamma": 33
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 51
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.25,
    "gamma": 0.015625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 306.0196847852814,
    "beta": 3.141592653589793,
    "gamma": 306.0196847852814
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.5,
    "gamma": 0.0078125
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 2,
    "beta": 1,
    "gamma": 8.915000000000003
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.5000000000000001,
    "gamma": 0.4999999999999999
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 41
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 890,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 120,
    "beta": 15,
    "gamma": 120
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 403.4287934927351,
    "beta": 20.085536923187668,
    "gamma": 403.4287934927351
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 216,
    "gamma": 546
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.1111111111111111,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 60,
    "beta": 6,
    "gamma": 396
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 468,
    "gamma": 630
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -34
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 36,
    "gamma": 330
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.0625,
    "beta": 0.015625,
    "gamma": 0.125
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 41
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.1111111111111111,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 39
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cetus",
    "alpha": 816,
    "beta": 126,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 321,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 805,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 5.4999999999999964
  },
  {
    "pattern": "Auriga",
    "alpha": 2,
    "beta": 5,
    "gamma": -8
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 11.390625,
    "beta": 3.375,
    "gamma": 17.0859375
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 60,
    "beta": 18,
    "gamma": 126
  },
  {
    "pattern": "Pisces",
    "alpha": -2,
    "beta": 5,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 858
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 1597,
    "gamma": 8
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 63
  },
  {
    "pattern": "Andromeda",
    "alpha": 376,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 51
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 35
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 2.0000000000000004
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 21,
    "beta": 3,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 711
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cetus",
    "alpha": 546,
    "beta": 36,
    "gamma": 330
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Pisces",
    "alpha": 9,
    "beta": 4,
    "gamma": 49
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 892,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 659
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 270,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 888,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.25,
    "gamma": 0.03125
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 16,
    "beta": 4,
    "gamma": 32
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.1111111111111111,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.3333333333333333,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 377,
    "gamma": -8
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 625,
    "beta": 25,
    "gamma": 625
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 262,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 816,
    "beta": 330,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -21,
    "beta": 233,
    "gamma": 5
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 5,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 856
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 21,
    "beta": 610,
    "gamma": -89
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 850
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Scorpius",
    "alpha": 2.453701991420671,
    "beta": 3.5135856242857333,
    "gamma": 23.140692632779267
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 641
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 377,
    "gamma": -5
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 89,
    "gamma": -5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 403.4287934927351,
    "beta": 1,
    "gamma": 403.4287934927351
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 807,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 540,
    "gamma": 819
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 247,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 852
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 36,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 29
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 308,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 817,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Sculptor",
    "alpha": 2,
    "beta": 7.38905609893065,
    "gamma": 64
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 41
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.015625,
    "beta": 0.0078125,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 111,
    "beta": 34,
    "gamma": 369
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 2.800000000000001
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 2.718281828459045,
    "beta": 1,
    "gamma": 54.598150033144236
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 527,
    "gamma": 819
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 208,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 3,
    "gamma": 8
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 126,
    "gamma": 330
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Pisces",
    "alpha": 9,
    "beta": 4,
    "gamma": 81
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 538,
    "gamma": 819
  },
  {
    "pattern": "Auriga",
    "alpha": 5,
    "beta": 13,
    "gamma": -21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.125,
    "gamma": 0.0625
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 66,
    "beta": 20.999999999999996,
    "gamma": 214.49999999999997
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 111,
    "beta": 65,
    "gamma": 369
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 486,
    "beta": 18,
    "gamma": 486
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 53
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 57
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 41
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Pisces",
    "alpha": 7,
    "beta": 4,
    "gamma": 37
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.25,
    "gamma": 0.0078125
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 53
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -987
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.125,
    "gamma": 0.125
  },
  {
    "pattern": "Pisces",
    "alpha": 3.5135856242857333,
    "beta": 2.849653908226361,
    "gamma": 23.140692632779267
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 2.9000000000000012
  },
  {
    "pattern": "Andromeda",
    "alpha": 343,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 893,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.125,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 18,
    "gamma": 396
  },
  {
    "pattern": "Lepus",
    "alpha": 1,
    "beta": 0.4999999999999999,
    "gamma": 1.4997597826618576
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 2,
    "gamma": 3
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.015625,
    "gamma": 0.0625
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 5,
    "gamma": 60
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 36,
    "gamma": 270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 91,
    "beta": 15,
    "gamma": 120
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 888,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 887,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.25,
    "gamma": 0.0078125
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.1111111111111111,
    "beta": 0.3333333333333333,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Andromeda",
    "alpha": 320,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.5,
    "gamma": 0.0625
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 128,
    "beta": 16,
    "gamma": 512
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 43
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 258,
    "beta": 39,
    "gamma": 399
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 216,
    "gamma": 546
  },
  {
    "pattern": "Scorpius",
    "alpha": 27,
    "beta": 3,
    "gamma": 27
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -2,
    "beta": 55,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Auriga",
    "alpha": 2,
    "beta": 13,
    "gamma": -21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.015625,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 851
  },
  {
    "pattern": "Pisces",
    "alpha": 5,
    "beta": 5,
    "gamma": 65
  },
  {
    "pattern": "Sagitta",
    "alpha": -6,
    "beta": 90,
    "gamma": -6
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cetus",
    "alpha": 816,
    "beta": 270,
    "gamma": 546
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 189,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.5,
    "gamma": 0.015625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 450,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 100,
    "beta": 15,
    "gamma": 260
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 2,
    "gamma": -8
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -1,
    "beta": 100,
    "gamma": -2
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 3,
    "beta": 987,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Pisces",
    "alpha": 2.25,
    "beta": 2.25,
    "gamma": 25.62890625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Aquarius",
    "alpha": -36,
    "beta": 36,
    "gamma": -18
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 13,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 674
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 64,
    "beta": 4,
    "gamma": 64
  },
  {
    "pattern": "Pisces",
    "alpha": 2.5,
    "beta": 2.5,
    "gamma": 20.999999999999996
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.5,
    "gamma": 0.0078125
  },
  {
    "pattern": "Pisces",
    "alpha": 34,
    "beta": 15,
    "gamma": 175
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 144,
    "gamma": 2
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 60,
    "gamma": 468
  },
  {
    "pattern": "Scorpius",
    "alpha": 20.999999999999996,
    "beta": 2.5,
    "gamma": 20.999999999999996
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 89,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 3,
    "gamma": -8
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 5,
    "beta": 1597,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 850
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 55,
    "beta": 2,
    "gamma": 55
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 1597,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 845
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 18,
    "gamma": 126
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.25,
    "beta": 0.5,
    "gamma": 0.00390625
  },
  {
    "pattern": "Auriga",
    "alpha": -8,
    "beta": 144,
    "gamma": 144
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.5000000000000002,
    "gamma": 0.5000000000000002
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 810,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 18,
    "gamma": 270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.0001524157902758725,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 1597,
    "gamma": 5
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -5,
    "beta": 89,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 8,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 190,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 2.718281828459045,
    "beta": 1,
    "gamma": 20.085536923187668
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 65
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.5,
    "gamma": 0.00390625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -13,
    "beta": 233,
    "gamma": -21
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -3,
    "beta": 89,
    "gamma": -8
  },
  {
    "pattern": "Sculptor",
    "alpha": 369,
    "beta": 111,
    "gamma": 175
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -3,
    "beta": 144,
    "gamma": -13
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 8,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 800,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 214.49999999999997,
    "beta": 20.999999999999996,
    "gamma": 214.49999999999997
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 37
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.125,
    "gamma": 0.0625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 847
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 3.3000000000000016
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 307,
    "gamma": 610
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 8,
    "beta": 144,
    "gamma": -34
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 5,
    "beta": 233,
    "gamma": -34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.0078125,
    "gamma": 0.25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 3.5000000000000018
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 0.1
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 330,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 13,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 233,
    "gamma": 34
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 3,
    "gamma": 48
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 19
  },
  {
    "pattern": "Andromeda",
    "alpha": 329,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.5,
    "gamma": 0.25
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 61
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 47
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.5000000000000001,
    "gamma": 0.5000000000000002
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 20,
    "beta": 4,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 843
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 33
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 648
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 4.300000000000001
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.0625,
    "gamma": 0.03125
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 663
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 892,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 65
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 21,
    "beta": 6,
    "gamma": 45
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 111,
    "beta": 15,
    "gamma": 175
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.25,
    "gamma": 0.0625
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Pisces",
    "alpha": 2.718281828459045,
    "beta": 2.718281828459045,
    "gamma": 20.085536923187668
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 891,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 377,
    "gamma": 5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 16,
    "beta": 4,
    "gamma": 49
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 41
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.4999999999999999,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 60,
    "gamma": 330
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 168,
    "gamma": 630
  },
  {
    "pattern": "Aquarius",
    "alpha": -36,
    "beta": 60,
    "gamma": -6
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 848
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.5,
    "gamma": 0.125
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 195,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 233,
    "beta": 89,
    "gamma": 377
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 857
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 144,
    "gamma": 144
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.3333333333333333,
    "beta": 0.3333333333333333,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 27
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 15,
    "beta": 3,
    "gamma": 36
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 8,
    "beta": 377,
    "gamma": -55
  },
  {
    "pattern": "Andromeda",
    "alpha": 278,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cetus",
    "alpha": 546,
    "beta": 168,
    "gamma": 396
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 316,
    "gamma": 610
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.015625,
    "beta": 0.015625,
    "gamma": 0.03125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 49
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 814,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Crux",
    "alpha": 1075,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0,
    "beta": 0.5000000000000001,
    "gamma": 1
  },
  {
    "pattern": "Andromeda",
    "alpha": 283,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 19
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 17.0859375,
    "beta": 3.375,
    "gamma": 25.62890625
  },
  {
    "pattern": "Scorpius",
    "alpha": 2,
    "beta": 5,
    "gamma": 49
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -8,
    "beta": 233,
    "gamma": -13
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 7,
    "beta": 2,
    "gamma": 29
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 36,
    "gamma": 270
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 60,
    "beta": 6,
    "gamma": 90
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 815,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 36,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Sculptor",
    "alpha": 90,
    "beta": 90,
    "gamma": 330
  },
  {
    "pattern": "Pisces",
    "alpha": -34,
    "beta": 2,
    "gamma": -21
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 468,
    "gamma": 720
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 154
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 37
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 49
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 662
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 37
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 41
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 27
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 610,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 81,
    "beta": 3,
    "gamma": 81
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 851
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 241,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 60,
    "gamma": 216
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -18,
    "beta": 468,
    "gamma": -270
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 396,
    "gamma": 720
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 18.970074962999995,
    "beta": 2.667,
    "gamma": 134.93203753349806
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 55,
    "gamma": -144
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 18,
    "beta": 3,
    "gamma": 50
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": -3
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 33
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 13,
    "gamma": 5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 36,
    "gamma": 546
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 60,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 512,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 31
  },
  {
    "pattern": "Crux",
    "alpha": 907,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 66,
    "beta": 6,
    "gamma": 153
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 51
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 270,
    "beta": 36,
    "gamma": 216
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.25,
    "gamma": 0.0078125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 369,
    "beta": 5,
    "gamma": 369
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 126,
    "gamma": 468
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -13,
    "beta": 144,
    "gamma": -2
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 814,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 33
  },
  {
    "pattern": "Aquarius",
    "alpha": 0,
    "beta": 3.58351893845611,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 853
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 153
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 25,
    "beta": 4,
    "gamma": 169
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.03703703703703703,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.6931471805599453,
    "beta": 0.6931471805599453,
    "gamma": 2.0794415416798357
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 17
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 8,
    "gamma": 5
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 49
  },
  {
    "pattern": "Pisces",
    "alpha": -8,
    "beta": 5,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 2.400000000000001
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.25,
    "gamma": 0.25
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 34,
    "gamma": -55
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 304,
    "gamma": 610
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -8,
    "beta": 233,
    "gamma": 34
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 27
  },
  {
    "pattern": "Auriga",
    "alpha": -8,
    "beta": 34,
    "gamma": -55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": 8
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 45,
    "beta": 15,
    "gamma": 91
  },
  {
    "pattern": "Pisces",
    "alpha": -2,
    "beta": 2,
    "gamma": 5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 512,
    "beta": 128,
    "gamma": 512
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 8,
    "gamma": -8
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.25,
    "gamma": 0.25
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 49
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 25
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 49
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 2,
    "beta": 1,
    "gamma": 8.899999999999997
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 144,
    "gamma": -34
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 207,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 2,
    "gamma": 16
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 651
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 29
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 21
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 309,
    "gamma": 610
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 55,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 842
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 895,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 90,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 585,
    "gamma": 819
  },
  {
    "pattern": "Lyra",
    "alpha": 1126,
    "beta": 109,
    "gamma": 94
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 100,
    "beta": 20,
    "gamma": 200
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.125,
    "gamma": 0.25
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.012345679012345677,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 530,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 2.2000000000000006
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.001371742112482853,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Draco",
    "alpha": 16,
    "beta": 4,
    "gamma": 576
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 34,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 654
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 0.30000000000000004
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 60,
    "beta": 6,
    "gamma": 168
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 39
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 53
  },
  {
    "pattern": "Andromeda",
    "alpha": 321,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Aquarius",
    "alpha": -2,
    "beta": 3,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 841
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 811,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 270,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 7.099999999999991
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Libra",
    "alpha": 3,
    "beta": 0,
    "gamma": 155
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 57
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 45,
    "beta": 6,
    "gamma": 153
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 19
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -21
  },
  {
    "pattern": "Auriga",
    "alpha": 8,
    "beta": 21,
    "gamma": -34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.25,
    "gamma": 0.0625
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.0625,
    "gamma": 0.25
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 0.5000000000000001,
    "gamma": 0.4999999999999999
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 847
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": 8
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.6931471805599453,
    "beta": 1.0986122886681096,
    "gamma": 2.1972245773362196
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 671
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.25,
    "gamma": 0.125
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 51
  },
  {
    "pattern": "Pisces",
    "alpha": 3.375,
    "beta": 2.25,
    "gamma": 25.62890625
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 19
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 396,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.03125,
    "gamma": 0.25
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 18,
    "gamma": 270
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 60,
    "gamma": 396
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 55
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 60,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 847
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 65,
    "beta": 5,
    "gamma": 260
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 377,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 841
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 47
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 64,
    "beta": 16,
    "gamma": 256
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 63
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 57
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 377,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.012345679012345677,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.03125,
    "gamma": 0.25
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.25,
    "gamma": 0.00390625
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 987,
    "gamma": 5
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 47
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 37
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 2,
    "beta": 21,
    "gamma": -8
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 155,
    "beta": 39,
    "gamma": 399
  },
  {
    "pattern": "Sculptor",
    "alpha": 0.25,
    "beta": 0.03125,
    "gamma": 0.25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 55,
    "gamma": -55
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 5,
    "gamma": -5
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 23
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 39,
    "gamma": 37
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 47
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 34,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.25,
    "gamma": 0.0625
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 610,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 13,
    "beta": 1597,
    "gamma": -55
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 7,
    "beta": 2,
    "gamma": 16
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 15
  },
  {
    "pattern": "Andromeda",
    "alpha": 281,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 11
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 655
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 43
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": -13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 36,
    "gamma": 546
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 987,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.5,
    "gamma": 0.0625
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 39
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 268,
    "gamma": 610
  },
  {
    "pattern": "Sculptor",
    "alpha": 0.4999999999999999,
    "beta": 1,
    "gamma": 1.4997597826618576
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 36,
    "gamma": 630
  },
  {
    "pattern": "Crux",
    "alpha": 939,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 41
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 657
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 45,
    "beta": 15,
    "gamma": 120
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 638
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 41
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 887,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 290,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 21,
    "beta": 377,
    "gamma": -89
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 853
  },
  {
    "pattern": "Andromeda",
    "alpha": 347,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 21,
    "gamma": 8
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.03703703703703703,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 90,
    "beta": 18,
    "gamma": 168
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 144,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 260,
    "beta": 34,
    "gamma": 260
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 621
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 265,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 585,
    "beta": 118,
    "gamma": 583
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 665
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.1111111111111111,
    "beta": 0.3333333333333333,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Sculptor",
    "alpha": 55,
    "beta": 34,
    "gamma": -89
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 36,
    "gamma": 630
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 21
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -18,
    "beta": 270,
    "gamma": -90
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 216,
    "gamma": 168
  },
  {
    "pattern": "Pisces",
    "alpha": 4,
    "beta": 4,
    "gamma": 64
  },
  {
    "pattern": "Pisces",
    "alpha": -34,
    "beta": 2,
    "gamma": 3
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 45
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 622
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 811,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Crux",
    "alpha": 963,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 29
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 270,
    "gamma": 630
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 91,
    "beta": 6,
    "gamma": 153
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 17
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 22,
    "beta": 2,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 155,
    "beta": 14,
    "gamma": 155
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.5,
    "gamma": 0.015625
  },
  {
    "pattern": "Aquarius",
    "alpha": -3,
    "beta": 2,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 850
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": -3
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 175,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 33
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 153,
    "beta": 15,
    "gamma": 153
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 39,
    "beta": 3,
    "gamma": 39
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 812,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": -2
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.0625,
    "gamma": 0.125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 13
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 45
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 11
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Aquarius",
    "alpha": -2,
    "beta": 5,
    "gamma": -13
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.6931471805599453,
    "beta": 1.0986122886681096,
    "gamma": 1.9459101490553132
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.125,
    "gamma": 0.125
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 314,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 55,
    "gamma": -2
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 134.93203753349806,
    "beta": 7.112888999999999,
    "gamma": 359.8637441018393
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 852
  },
  {
    "pattern": "Pisces",
    "alpha": -8,
    "beta": 2,
    "gamma": -21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 7.999999999999988
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 125,
    "beta": 8,
    "gamma": 125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 49
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 11
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 853
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 1.6000000000000003
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Pisces",
    "alpha": -8,
    "beta": 3,
    "gamma": 8
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 8,
    "gamma": -3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 34,
    "beta": 2,
    "gamma": 34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.012345679012345677,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 283,
    "gamma": 610
  },
  {
    "pattern": "Sagitta",
    "alpha": -8,
    "beta": 144,
    "gamma": 2
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -89
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 21,
    "beta": 377,
    "gamma": -144
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 11
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 809,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 39
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 856
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.0625,
    "gamma": 0.5
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 53
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.03703703703703703,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 11,
    "beta": 2,
    "gamma": 16
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 144,
    "gamma": 3
  },
  {
    "pattern": "Crux",
    "alpha": 1003,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 89,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 987,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 194,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": 4,
    "beta": 2,
    "gamma": 37
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 441,
    "beta": 169,
    "gamma": 441
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 13,
    "gamma": -5
  },
  {
    "pattern": "Aquarius",
    "alpha": 16,
    "beta": 9,
    "gamma": 81
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 41,
    "gamma": 25
  },
  {
    "pattern": "Pisces",
    "alpha": 9,
    "beta": 4,
    "gamma": 100
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 806,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 18,
    "gamma": 546
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 33
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 987,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 144,
    "gamma": -34
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 9.399999999999995
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 261,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 812,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 27
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 617
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 2,
    "beta": 233,
    "gamma": -55
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 300,
    "beta": 30,
    "gamma": 300
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 610,
    "gamma": 2
  },
  {
    "pattern": "Andromeda",
    "alpha": 334,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 155,
    "beta": 39,
    "gamma": 258
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 377,
    "gamma": -21
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 334,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 1140,
    "beta": 168,
    "gamma": 126
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 323,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 59
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -2,
    "beta": 144,
    "gamma": -13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.5,
    "gamma": 0.03125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 620
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 60,
    "beta": 6,
    "gamma": 270
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 21,
    "gamma": 3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 710,
    "beta": 76,
    "gamma": 710
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 61
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": -8
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 809,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 855
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 18,
    "beta": 3,
    "gamma": 51
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 299,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 5,
    "gamma": 8
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 61
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.00390625,
    "beta": 0.0078125,
    "gamma": 0.25
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -2,
    "beta": 144,
    "gamma": 8
  },
  {
    "pattern": "Aquarius",
    "alpha": -6,
    "beta": 18,
    "gamma": -36
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 60,
    "gamma": 270
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.1111111111111111,
    "beta": 0.1111111111111111,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 45,
    "beta": 6,
    "gamma": 66
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 843
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 180,
    "gamma": 610
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 55,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 54,
    "beta": 6,
    "gamma": 486
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 2.700000000000001
  },
  {
    "pattern": "Pisces",
    "alpha": -34,
    "beta": 3,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 889,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 233,
    "gamma": 34
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.5,
    "gamma": 0.00390625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 887,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Pisces",
    "alpha": 3,
    "beta": 5,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 854
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 51
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 45
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 857
  },
  {
    "pattern": "Sagitta",
    "alpha": -8,
    "beta": 89,
    "gamma": 5
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 23
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 377,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 851
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 55,
    "gamma": -233
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 512,
    "beta": 125,
    "gamma": 512
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 13,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 815,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 847
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 642
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.03125,
    "gamma": 0.0625
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 9.699999999999994
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 43
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.03125,
    "gamma": 0.25
  },
  {
    "pattern": "Pisces",
    "alpha": -8,
    "beta": 2,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 128,
    "beta": 64,
    "gamma": 256
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 3,
    "gamma": 34
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 34,
    "gamma": -55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 175,
    "beta": 34,
    "gamma": 260
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 852
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 240,
    "gamma": 610
  },
  {
    "pattern": "Andromeda",
    "alpha": 316,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 36,
    "beta": 6,
    "gamma": 270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 16,
    "beta": 4,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 33
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -2,
    "beta": 89,
    "gamma": -3
  },
  {
    "pattern": "Auriga",
    "alpha": 5,
    "beta": 55,
    "gamma": -89
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 65
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 3.2000000000000015
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 812,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Pisces",
    "alpha": 3,
    "beta": 2,
    "gamma": 34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.015625,
    "gamma": 0.03125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 851
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 1.3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 34,
    "beta": 5,
    "gamma": 65
  },
  {
    "pattern": "Aquarius",
    "alpha": -3,
    "beta": 5,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 815,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 13,
    "gamma": -34
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 699
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.6931471805599453,
    "beta": 1.0986122886681096,
    "gamma": 2.0794415416798357
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.015625,
    "gamma": 0.25
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 8,
    "beta": 610,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 45
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 168,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Aquarius",
    "alpha": 0,
    "beta": 2.772588722239781,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 91,
    "beta": 15,
    "gamma": 153
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 36,
    "beta": 3,
    "gamma": 45
  },
  {
    "pattern": "Auriga",
    "alpha": 2,
    "beta": 89,
    "gamma": -144
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 51
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 41
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 36,
    "gamma": 270
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -6,
    "beta": 396,
    "gamma": -126
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 39,
    "gamma": 33
  },
  {
    "pattern": "Lyra",
    "alpha": 1140,
    "beta": 126,
    "gamma": 18
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 809,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 39,
    "gamma": 27
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 675
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 725
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 23
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.25,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -8,
    "beta": 89,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 43
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 20.085536923187668,
    "beta": 1,
    "gamma": 20.085536923187668
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 297,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 584,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 610,
    "gamma": 5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 16,
    "beta": 2,
    "gamma": 37
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 57
  },
  {
    "pattern": "Pisces",
    "alpha": 7.112888999999999,
    "beta": 2.667,
    "gamma": 50.59318992632099
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 856
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 90,
    "gamma": 330
  },
  {
    "pattern": "Leo",
    "alpha": 2,
    "beta": 1,
    "gamma": 49
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 468,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 6,
    "gamma": 168
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 8,
    "gamma": 13
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 28,
    "beta": 3,
    "gamma": 45
  },
  {
    "pattern": "Andromeda",
    "alpha": 324,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -8,
    "beta": 233,
    "gamma": -5
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 3,
    "gamma": 3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 891,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 100,
    "beta": 10,
    "gamma": 300
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 844
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 818,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 702
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 126,
    "gamma": 396
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 289,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 14,
    "beta": 3,
    "gamma": 39
  },
  {
    "pattern": "Aquarius",
    "alpha": -3,
    "beta": 3,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 126,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 814,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 3,
    "beta": 89,
    "gamma": -13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 60,
    "gamma": 330
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 17.0859375,
    "beta": 1.5,
    "gamma": 17.0859375
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Scorpius",
    "alpha": 3.5135856242857333,
    "beta": 4.810477380965351,
    "gamma": 23.140692632779267
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 305,
    "gamma": 610
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 2,
    "gamma": -5
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 5,
    "gamma": 13
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": -55
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 0.1
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 2,
    "gamma": 8
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 54,
    "beta": 6,
    "gamma": 162
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 858
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 260,
    "beta": 111,
    "gamma": 260
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 33
  },
  {
    "pattern": "Pisces",
    "alpha": 15,
    "beta": 5,
    "gamma": 111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 5,
    "beta": 233,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 126,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Sagitta",
    "alpha": -8,
    "beta": 144,
    "gamma": 34
  },
  {
    "pattern": "Lyra",
    "alpha": 1458,
    "beta": 162,
    "gamma": 54
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": -13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 45,
    "beta": 3,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -18,
    "beta": 396,
    "gamma": -270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 987,
    "gamma": 2
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 249,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 891,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 47
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 18,
    "gamma": 468
  },
  {
    "pattern": "Pisces",
    "alpha": -5,
    "beta": 8,
    "gamma": -55
  },
  {
    "pattern": "Pisces",
    "alpha": 21,
    "beta": 7.38905609893065,
    "gamma": 128
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 260,
    "beta": 111,
    "gamma": 369
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 8,
    "gamma": 5
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.03125,
    "beta": 0.015625,
    "gamma": 0.125
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 5,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.1111111111111111,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 893,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 888,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 613
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 850
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 168,
    "gamma": 546
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 51
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 45
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 199,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 63
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 843
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 111,
    "beta": 15,
    "gamma": 111
  },
  {
    "pattern": "Scorpius",
    "alpha": 2.25,
    "beta": 3.375,
    "gamma": 25.62890625
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 333,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 857
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 61
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 853
  },
  {
    "pattern": "Aquarius",
    "alpha": -2,
    "beta": 13,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Andromeda",
    "alpha": 275,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 2,
    "gamma": -8
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 90,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 894,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Lyra",
    "alpha": 1600,
    "beta": 377,
    "gamma": 21
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 25,
    "beta": 4,
    "gamma": 81
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 4.100000000000001
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 155,
    "beta": 84,
    "gamma": 399
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 41,
    "gamma": 33
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 34,
    "gamma": -55
  },
  {
    "pattern": "Sculptor",
    "alpha": 34,
    "beta": 21,
    "gamma": -55
  },
  {
    "pattern": "Aquarius",
    "alpha": -18,
    "beta": 36,
    "gamma": -60
  },
  {
    "pattern": "Aquarius",
    "alpha": -6,
    "beta": 6,
    "gamma": -18
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -34,
    "beta": 144,
    "gamma": 89
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 43
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 704
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 90,
    "gamma": 546
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 53
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 175,
    "beta": 65,
    "gamma": 260
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 65,
    "beta": 15,
    "gamma": 260
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 66,
    "beta": 15,
    "gamma": 153
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 842
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0,
    "gamma": 1.6000000000000003
  },
  {
    "pattern": "Andromeda",
    "alpha": 337,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.3333333333333333,
    "beta": 0.3333333333333333,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 8,
    "beta": 987,
    "gamma": -34
  },
  {
    "pattern": "Auriga",
    "alpha": 5,
    "beta": 34,
    "gamma": -55
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 216,
    "gamma": 630
  },
  {
    "pattern": "Lyra",
    "alpha": 1140,
    "beta": 90,
    "gamma": 126
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 35
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 0.9999999999999999
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 278,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Andromeda",
    "alpha": 330,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 160
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.125,
    "gamma": 0.5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 60,
    "gamma": 270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 19
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 8,
    "beta": 2,
    "gamma": 16
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Crux",
    "alpha": 1050,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Pisces",
    "alpha": 25,
    "beta": 9,
    "gamma": 144
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 5,
    "beta": 89,
    "gamma": -21
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 317,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 679
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 34,
    "gamma": -8
  },
  {
    "pattern": "Scorpius",
    "alpha": 4,
    "beta": 4,
    "gamma": 16
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Auriga",
    "alpha": 8,
    "beta": 55,
    "gamma": -89
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 216,
    "gamma": 126
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -3,
    "beta": 89,
    "gamma": -2
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0,
    "beta": 0.4999999999999999,
    "gamma": 1
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 178,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.3333333333333333,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 19
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 15,
    "beta": 3,
    "gamma": 28
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 852
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 36,
    "beta": 3,
    "gamma": 36
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -2,
    "beta": 89,
    "gamma": -5
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 336,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 28,
    "beta": 6,
    "gamma": 45
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 13
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 49
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.3333333333333333,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Lyra",
    "alpha": 1189,
    "beta": 175,
    "gamma": 10
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 335,
    "gamma": 610
  },
  {
    "pattern": "Sagitta",
    "alpha": -18,
    "beta": 168,
    "gamma": -18
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 19,
    "beta": 3,
    "gamma": 51
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 111,
    "beta": 5,
    "gamma": 260
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 90,
    "gamma": 468
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 258,
    "beta": 3,
    "gamma": 258
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 13
  },
  {
    "pattern": "Pisces",
    "alpha": 4,
    "beta": 4,
    "gamma": 36
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -3,
    "beta": 144,
    "gamma": -8
  },
  {
    "pattern": "Andromeda",
    "alpha": 285,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Pisces",
    "alpha": 3,
    "beta": 3,
    "gamma": 36
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.25,
    "gamma": 0.125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 5.0625,
    "beta": 1.5,
    "gamma": 17.0859375
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 175,
    "beta": 5,
    "gamma": 260
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.25,
    "gamma": 0.125
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0,
    "gamma": 1.3862943611198906
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.015625,
    "gamma": 0.015625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 89,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 34,
    "beta": 5,
    "gamma": 175
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 293,
    "gamma": 610
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 650
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 63
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 33
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 13,
    "gamma": 13
  },
  {
    "pattern": "Lyra",
    "alpha": 1610,
    "beta": 377,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 987,
    "gamma": -3
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.25,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": -13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 2,
    "beta": 1,
    "gamma": 8.9
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 11
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 689
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 144,
    "gamma": 144
  },
  {
    "pattern": "Andromeda",
    "alpha": 125,
    "beta": 125,
    "gamma": 512
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 33
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 709
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 515,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.5,
    "gamma": 0.0078125
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 396,
    "gamma": 630
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 3,
    "gamma": -3
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 1597,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 849
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 60,
    "gamma": 396
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 32,
    "beta": 8,
    "gamma": 64
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 29
  },
  {
    "pattern": "Pisces",
    "alpha": 3,
    "beta": 3,
    "gamma": 28
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 848
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 233,
    "beta": 89,
    "gamma": 233
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 856
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.25,
    "gamma": 0.03125
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.015625,
    "gamma": 0.125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 501,
    "gamma": 819
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 258,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 817,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 508,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 812,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 987,
    "gamma": 5
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 233,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 694
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 126,
    "gamma": 396
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 2,
    "gamma": 2
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.25,
    "gamma": 0.0625
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 41
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 857
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 55,
    "gamma": -13
  },
  {
    "pattern": "Pisces",
    "alpha": 9,
    "beta": 3,
    "gamma": 81
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 856
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 848
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 5,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 34,
    "gamma": -5
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 21,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.012345679012345677,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 60,
    "gamma": 330
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 851
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 111,
    "beta": 65,
    "gamma": 260
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 0.6
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 36,
    "gamma": 216
  },
  {
    "pattern": "Sculptor",
    "alpha": 0.25,
    "beta": 0.125,
    "gamma": 0.25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 584,
    "beta": 118,
    "gamma": 584
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -8,
    "beta": 233,
    "gamma": 5
  },
  {
    "pattern": "Andromeda",
    "alpha": 327,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Pisces",
    "alpha": 2.25,
    "beta": 1.5,
    "gamma": 11.390625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 812,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 857
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 34,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 23
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 69
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Sagitta",
    "alpha": -2,
    "beta": 144,
    "gamma": 3
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": -13
  },
  {
    "pattern": "Sculptor",
    "alpha": 376,
    "beta": 111,
    "gamma": 175
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 8,
    "beta": 2,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 187.91462850239847,
    "beta": 23.140692632779267,
    "gamma": 187.91462850239847
  },
  {
    "pattern": "Scorpius",
    "alpha": 37,
    "beta": 4,
    "gamma": 37
  },
  {
    "pattern": "Sculptor",
    "alpha": 13,
    "beta": 20.085536923187668,
    "gamma": 128
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 13,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 90,
    "gamma": 270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 813,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 34,
    "beta": 5,
    "gamma": 111
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 13,
    "beta": 987,
    "gamma": -55
  },
  {
    "pattern": "Pisces",
    "alpha": 15,
    "beta": 6,
    "gamma": 120
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 60,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 526,
    "gamma": 819
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 377,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 627
  },
  {
    "pattern": "Pisces",
    "alpha": 16,
    "beta": 9,
    "gamma": 100
  },
  {
    "pattern": "Pisces",
    "alpha": -3,
    "beta": 3,
    "gamma": -21
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -18,
    "beta": 216,
    "gamma": -36
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 700
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 298,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Sculptor",
    "alpha": 0,
    "beta": 0.4999999999999999,
    "gamma": 1.4997597826618576
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 60,
    "beta": 36,
    "gamma": 270
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.0625,
    "gamma": 0.015625
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 37
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 90,
    "gamma": 630
  },
  {
    "pattern": "Auriga",
    "alpha": 13,
    "beta": 34,
    "gamma": -55
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 100,
    "beta": 2,
    "gamma": 100
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 3.0000000000000013
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 29
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 3,
    "gamma": 5
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 89,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 468,
    "gamma": 720
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 31
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 65
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 813,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": -8
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 8,
    "beta": 233,
    "gamma": -233
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 100
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.5,
    "gamma": 0.5
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.3333333333333333,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.5000000000000002,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 37
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.25,
    "gamma": 0.25
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 11
  },
  {
    "pattern": "Pisces",
    "alpha": 2.849653908226361,
    "beta": 2.849653908226361,
    "gamma": 23.140692632779267
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 89,
    "gamma": 2
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 22,
    "beta": 2,
    "gamma": 22
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 806,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 90,
    "gamma": 396
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 5,
    "gamma": -2
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 691
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 91,
    "beta": 28,
    "gamma": 153
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Auriga",
    "alpha": 2,
    "beta": 8,
    "gamma": -13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.5,
    "gamma": 0.25
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 41
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.3333333333333333,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 57
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Sculptor",
    "alpha": 0,
    "beta": 0.5000000000000002,
    "gamma": 1.4997597826618576
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 19
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 168,
    "gamma": 396
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 2.1000000000000005
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 134.93203753349806,
    "beta": 50.59318992632099,
    "gamma": 359.8637441018393
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 21
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 61
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.00045724737082761756,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 5,
    "beta": 144,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 520,
    "gamma": 819
  },
  {
    "pattern": "Andromeda",
    "alpha": 279,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.3333333333333333,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 812,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Andromeda",
    "alpha": 303,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 192,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 55,
    "gamma": -5
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.6931471805599453,
    "beta": 0.6931471805599453,
    "gamma": 1.6094379124341003
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Lyra",
    "alpha": 1189,
    "beta": 175,
    "gamma": 94
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 216,
    "beta": 18,
    "gamma": 546
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 84,
    "beta": 84,
    "gamma": 399
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 15
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 3.1000000000000014
  },
  {
    "pattern": "Lyra",
    "alpha": 987,
    "beta": 89,
    "gamma": 377
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.5,
    "gamma": 0.00390625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 37
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.00390625,
    "beta": 0.015625,
    "gamma": 0.0078125
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 610,
    "gamma": -5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 2.2000000000000006
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 894,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 60,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 892,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 656
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 59
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 126,
    "gamma": 6
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 216,
    "gamma": 468
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 39
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 126,
    "gamma": 396
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 49
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Scorpius",
    "alpha": 21,
    "beta": 7.38905609893065,
    "gamma": 64
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 258,
    "beta": 39,
    "gamma": 258
  },
  {
    "pattern": "Crux",
    "alpha": 931,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 81,
    "beta": 27,
    "gamma": 243
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 29
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 168,
    "gamma": 90
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.25,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.125,
    "gamma": 0.25
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0,
    "gamma": 0.6
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 893,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 65
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 813,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 33
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 89,
    "gamma": 5
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 65
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.0625,
    "gamma": 0.125
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 4.000000000000002
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 59
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 231,
    "gamma": 610
  },
  {
    "pattern": "Sculptor",
    "alpha": 0.25,
    "beta": 0.0078125,
    "gamma": 0.25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Crux",
    "alpha": 971,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 1.8000000000000005
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 97.40909103400242,
    "beta": 9.869604401089358,
    "gamma": 97.40909103400242
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 256,
    "beta": 32,
    "gamma": 512
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 216,
    "gamma": 630
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 251,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 850,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 90,
    "beta": 6,
    "gamma": 90
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 61
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 90,
    "beta": 18,
    "gamma": 270
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.0625,
    "gamma": 0.25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Lyra",
    "alpha": 1458,
    "beta": 54,
    "gamma": 54
  },
  {
    "pattern": "Sculptor",
    "alpha": 60,
    "beta": 270,
    "gamma": 1140
  },
  {
    "pattern": "Pisces",
    "alpha": 4,
    "beta": 4,
    "gamma": 22
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 34,
    "beta": 3,
    "gamma": 55
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.03125,
    "gamma": 0.125
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 89,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 111,
    "beta": 5,
    "gamma": 175
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 156
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 854
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 816,
    "beta": 90,
    "gamma": 546
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 36,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 4.100000000000001
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 19
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -55
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 43
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 1.8000000000000005
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 1597,
    "gamma": -2
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 91,
    "beta": 6,
    "gamma": 91
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.0625,
    "gamma": 0.5
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 65
  },
  {
    "pattern": "Sculptor",
    "alpha": 372,
    "beta": 111,
    "gamma": 175
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -21,
    "beta": 233,
    "gamma": -21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 126,
    "gamma": 630
  },
  {
    "pattern": "Pisces",
    "alpha": -5,
    "beta": 8,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 90,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.5,
    "gamma": 0.00390625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 850
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 541,
    "gamma": 819
  },
  {
    "pattern": "Leo",
    "alpha": 2,
    "beta": 1,
    "gamma": 48
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 523,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 90,
    "beta": 18,
    "gamma": 216
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 43
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 53
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Pisces",
    "alpha": 4,
    "beta": 4,
    "gamma": 49
  },
  {
    "pattern": "Leo",
    "alpha": 20.085536923187668,
    "beta": 2.718281828459045,
    "gamma": 148.4131591025766
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 858
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 25,
    "beta": 4,
    "gamma": 144
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 168,
    "beta": 18,
    "gamma": 468
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 3,
    "gamma": -13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 90,
    "gamma": 396
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 55,
    "beta": 5,
    "gamma": 55
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.3333333333333333,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 15
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.004115226337448558,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 842
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 296,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 0.5
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.0625,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -8,
    "beta": 89,
    "gamma": -5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 126,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 396,
    "gamma": 816
  },
  {
    "pattern": "Auriga",
    "alpha": 8,
    "beta": 34,
    "gamma": -55
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 377,
    "gamma": -5
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 987,
    "gamma": -8
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 144,
    "gamma": 144
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": 13
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 13
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 59
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 33
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 60,
    "gamma": 396
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 59
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 23
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 5,
    "gamma": -3
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 49
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -13,
    "beta": 233,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 891,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Sculptor",
    "alpha": 368,
    "beta": 111,
    "gamma": 175
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 35
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 84,
    "beta": 39,
    "gamma": 399
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 849
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 855
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 5,
    "gamma": 59
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 1.7000000000000004
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 3.800000000000002
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 15
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.1111111111111111,
    "beta": 0.3333333333333333,
    "gamma": 0.0001524157902758725
  },
  {
    "pattern": "Scorpius",
    "alpha": 5.0625,
    "beta": 3.375,
    "gamma": 11.390625
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 39,
    "gamma": 45
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 18,
    "gamma": 330
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 18,
    "gamma": 396
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 53
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.015625,
    "gamma": 0.0625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 504,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 126,
    "gamma": 396
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 168,
    "beta": 36,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -5,
    "beta": 144,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Andromeda",
    "alpha": 546,
    "beta": 330,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 0.5000000000000001,
    "gamma": 0.5000000000000002
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -21,
    "beta": 233,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 808,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.012345679012345677,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 47
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 21,
    "beta": 5,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 11
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 15
  },
  {
    "pattern": "Sculptor",
    "alpha": 368,
    "beta": 108,
    "gamma": 175
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 8,
    "beta": 2,
    "gamma": 64
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 1.3862943611198906,
    "gamma": 0
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 57
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 29
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 185,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 369,
    "beta": 65,
    "gamma": 369
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 64,
    "beta": 9,
    "gamma": 441
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0,
    "beta": 1,
    "gamma": 0.5000000000000001
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 254,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 2,
    "beta": 1,
    "gamma": 8.599999999999998
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.4999999999999999,
    "gamma": 0.5000000000000001
  },
  {
    "pattern": "Pisces",
    "alpha": 7.38905609893065,
    "beta": 2.718281828459045,
    "gamma": 54.598150033144236
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 25,
    "beta": 4,
    "gamma": 121
  },
  {
    "pattern": "Pisces",
    "alpha": 5,
    "beta": 7.38905609893065,
    "gamma": 64
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 396,
    "beta": 36,
    "gamma": 720
  },
  {
    "pattern": "Auriga",
    "alpha": 3,
    "beta": 13,
    "gamma": -21
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 1597,
    "gamma": -5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 377,
    "beta": 144,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 25,
    "beta": 4,
    "gamma": 225
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 18,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 223,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 514,
    "gamma": 819
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 0.4999999999999999,
    "gamma": 0.4999999999999999
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 842
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 852
  },
  {
    "pattern": "Scorpius",
    "alpha": 2,
    "beta": 5,
    "gamma": 48
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 512,
    "beta": 32,
    "gamma": 512
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 1597,
    "gamma": 3
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0,
    "gamma": 1.3
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 260,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 887,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 891,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.0078125,
    "gamma": 0.5
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 29
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.1111111111111111,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 21,
    "beta": 2,
    "gamma": 34
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 39
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 54,
    "beta": 18,
    "gamma": 162
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 41,
    "gamma": 27
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 5,
    "gamma": -13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 0.6
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.25,
    "gamma": 0.5
  },
  {
    "pattern": "Pisces",
    "alpha": 3,
    "beta": 2,
    "gamma": 21
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 0.4999999999999999,
    "gamma": 0.5000000000000002
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.03125,
    "gamma": 0.5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 60,
    "beta": 6,
    "gamma": 60
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 60,
    "gamma": 330
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 0.7999999999999999
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 216,
    "gamma": 546
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 61
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 47
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 36,
    "gamma": 396
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.125,
    "gamma": 0.25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 6,
    "gamma": 396
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 91,
    "beta": 15,
    "gamma": 91
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -8,
    "beta": 233,
    "gamma": 2
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 55,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 125,
    "beta": 25,
    "gamma": 125
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 34,
    "gamma": -5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": -2
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 51
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 111,
    "beta": 34,
    "gamma": 175
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 11.390625,
    "beta": 2.25,
    "gamma": 17.0859375
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 610,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 889,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Pisces",
    "alpha": 3.5135856242857333,
    "beta": 2.453701991420671,
    "gamma": 23.140692632779267
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Andromeda",
    "alpha": 326,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 209,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0,
    "gamma": 1.0999999999999999
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.4999999999999999,
    "beta": 0.5000000000000002,
    "gamma": 1.4997597826618576
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 3,
    "gamma": -2
  },
  {
    "pattern": "Pisces",
    "alpha": 20.085536923187668,
    "beta": 20.085536923187668,
    "gamma": 148.4131591025766
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 25
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 168,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 5,
    "beta": 610,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 39,
    "gamma": 31
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 270,
    "gamma": 720
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 210,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 66,
    "beta": 15,
    "gamma": 91
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 0.5000000000000001,
    "gamma": 0.5000000000000001
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 174,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 851
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 7.59375,
    "beta": 1.5,
    "gamma": 25.62890625
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 100,
    "beta": 10,
    "gamma": 200
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Andromeda",
    "alpha": 310,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.5,
    "gamma": 0.125
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 25.62890625,
    "beta": 1.5,
    "gamma": 25.62890625
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 66,
    "beta": 7,
    "gamma": 66
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 49
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 214.49999999999997,
    "beta": 66,
    "gamma": 214.49999999999997
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 11
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.125,
    "gamma": 0.25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 3,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Sagitta",
    "alpha": -5,
    "beta": 89,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 36,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 887,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 272,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 3,
    "beta": 144,
    "gamma": -21
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 21
  },
  {
    "pattern": "Sculptor",
    "alpha": 368,
    "beta": 110,
    "gamma": 175
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 726
  },
  {
    "pattern": "Lyra",
    "alpha": 1026,
    "beta": 90,
    "gamma": 396
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 84,
    "beta": 14,
    "gamma": 258
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -3,
    "beta": 144,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 802,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 2,
    "beta": 13,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 11,
    "beta": 2,
    "gamma": 37
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 28,
    "beta": 6,
    "gamma": 66
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.001371742112482853,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 41
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Aquarius",
    "alpha": -2,
    "beta": 8,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 894,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 216,
    "gamma": 546
  },
  {
    "pattern": "Andromeda",
    "alpha": 270,
    "beta": 168,
    "gamma": 630
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 60,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 34,
    "gamma": 2
  },
  {
    "pattern": "Pisces",
    "alpha": -8,
    "beta": 3,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 162,
    "beta": 18,
    "gamma": 162
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.004115226337448558,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Scorpius",
    "alpha": 4.31529664799597,
    "beta": 4.31529664799597,
    "gamma": 17.26118659198388
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 55,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 8,
    "beta": 1597,
    "gamma": -34
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 168,
    "gamma": 546
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 66,
    "beta": 28,
    "gamma": 153
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 695
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 698
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 23
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 57
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 175,
    "beta": 65,
    "gamma": 369
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 806,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.3333333333333333,
    "gamma": 0.0001524157902758725
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 90,
    "gamma": 468
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.25,
    "gamma": 0.0625
  },
  {
    "pattern": "Andromeda",
    "alpha": 396,
    "beta": 270,
    "gamma": 720
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.1111111111111111,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 624
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 3,
    "gamma": -5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 18,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 3,
    "gamma": -8
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 3,
    "gamma": -34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.5,
    "gamma": 0.0625
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.3333333333333333,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 3,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 813,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 10
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 0.7
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 808,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 610,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Lyra",
    "alpha": 816,
    "beta": 90,
    "gamma": 468
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 0.8999999999999999
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 18,
    "gamma": 330
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.5,
    "gamma": 0.5
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.012345679012345677,
    "gamma": 0.0001524157902758725
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 218,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 61
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 6.499999999999993
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 61
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 50.75401951173493,
    "beta": 13.708195669102423,
    "gamma": 187.91462850239847
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": 89
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 2,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 2,
    "beta": 1,
    "gamma": 8.499999999999998
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 889,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.001371742112482853,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 806,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 144,
    "gamma": 13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.0625,
    "gamma": 0.125
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 3.3000000000000016
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 169,
    "beta": 4,
    "gamma": 169
  },
  {
    "pattern": "Andromeda",
    "alpha": 315,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 55,
    "beta": 3,
    "gamma": 55
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -8,
    "beta": 233,
    "gamma": -8
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 84,
    "beta": 14,
    "gamma": 155
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 6,
    "gamma": 630
  },
  {
    "pattern": "Crux",
    "alpha": 819,
    "beta": 118,
    "gamma": 584
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 330,
    "gamma": 630
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0,
    "gamma": 1.4000000000000001
  },
  {
    "pattern": "Pisces",
    "alpha": 2.25,
    "beta": 1.5,
    "gamma": 25.62890625
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 204,
    "gamma": 610
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 2,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 51
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Scorpius",
    "alpha": 11,
    "beta": 4,
    "gamma": 16
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 27
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 41,
    "gamma": 53
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 172,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 35
  },
  {
    "pattern": "Andromeda",
    "alpha": 342,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 41,
    "gamma": 27
  },
  {
    "pattern": "Lyra",
    "alpha": 1140,
    "beta": 90,
    "gamma": 330
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 43
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": -8
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.004115226337448558,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 270,
    "gamma": 546
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 66,
    "beta": 6,
    "gamma": 66
  },
  {
    "pattern": "Andromeda",
    "alpha": 286,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": 21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 51
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 65,
    "beta": 5,
    "gamma": 65
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 90,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 15
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 191,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 817,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 5,
    "gamma": 8
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 11
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.03125,
    "beta": 0.0078125,
    "gamma": 0.5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 216,
    "gamma": 546
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -13,
    "beta": 233,
    "gamma": -13
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 55,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 76,
    "beta": 10,
    "gamma": 76
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 155,
    "beta": 14,
    "gamma": 258
  },
  {
    "pattern": "Sculptor",
    "alpha": 373,
    "beta": 111,
    "gamma": 175
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.0625,
    "gamma": 0.03125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 809,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 128,
    "beta": 8,
    "gamma": 256
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 213,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 19
  },
  {
    "pattern": "Pisces",
    "alpha": 6,
    "beta": 6,
    "gamma": 60
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 809,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Scorpius",
    "alpha": 16,
    "beta": 2,
    "gamma": 16
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 2,
    "gamma": -8
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 144,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 856
  },
  {
    "pattern": "Pisces",
    "alpha": 2.849653908226361,
    "beta": 2.453701991420671,
    "gamma": 23.140692632779267
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 162
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 893,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 331,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 7.59375,
    "beta": 1.5,
    "gamma": 11.390625
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 36,
    "gamma": 330
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 610,
    "gamma": -13
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 626
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Andromeda",
    "alpha": 282,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 35
  },
  {
    "pattern": "Aquarius",
    "alpha": -3,
    "beta": 8,
    "gamma": -21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.3333333333333333,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 36,
    "gamma": 330
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": 3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 216,
    "gamma": 546
  },
  {
    "pattern": "Andromeda",
    "alpha": 301,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 25,
    "beta": 5,
    "gamma": 125
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 2,
    "gamma": 42
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Aquarius",
    "alpha": -3,
    "beta": 2,
    "gamma": -3
  },
  {
    "pattern": "Lepus",
    "alpha": 1,
    "beta": 1,
    "gamma": 1.4997597826618576
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.03703703703703703,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Pisces",
    "alpha": 5,
    "beta": 2,
    "gamma": 34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 582,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 126,
    "gamma": 468
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 60,
    "gamma": 216
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 65
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 668
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 330,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 890,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 810,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 90,
    "beta": 18,
    "gamma": 126
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 17
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 144,
    "gamma": -5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 650,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 39
  },
  {
    "pattern": "Pisces",
    "alpha": -5,
    "beta": 5,
    "gamma": -55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 5,
    "gamma": -13
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 640
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 7,
    "beta": 2,
    "gamma": 37
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 610,
    "gamma": -2
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 49
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 31
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 54.598150033144236,
    "beta": 2.718281828459045,
    "gamma": 54.598150033144236
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.0625,
    "gamma": 0.25
  },
  {
    "pattern": "Big Dipper",
    "alpha": -8,
    "beta": 2,
    "gamma": 13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 60,
    "gamma": 630
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 13
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 468,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.03125,
    "gamma": 0.25
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 11
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 13
  },
  {
    "pattern": "Aquarius",
    "alpha": -36,
    "beta": 60,
    "gamma": -18
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 6,
    "gamma": 168
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Pisces",
    "alpha": 3.375,
    "beta": 2.25,
    "gamma": 17.0859375
  },
  {
    "pattern": "Pisces",
    "alpha": -3,
    "beta": 5,
    "gamma": -34
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 216,
    "gamma": 610
  },
  {
    "pattern": "Cetus",
    "alpha": 1026,
    "beta": 330,
    "gamma": 630
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 729,
    "beta": 243,
    "gamma": 729
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 120,
    "beta": 6,
    "gamma": 120
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 55,
    "gamma": -34
  },
  {
    "pattern": "Auriga",
    "alpha": 21,
    "beta": 55,
    "gamma": -89
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 41,
    "gamma": 23
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Crux",
    "alpha": 899,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Andromeda",
    "alpha": 333,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 630
  },
  {
    "pattern": "Crux",
    "alpha": 1026,
    "beta": 468,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 817,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 90,
    "beta": 18,
    "gamma": 330
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 36,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 888,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.03125,
    "gamma": 0.0625
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 21,
    "gamma": -55
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.1111111111111111,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 0,
    "beta": 84,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 808,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 4.799999999999999
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 841
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.0001524157902758725,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Sagitta",
    "alpha": -5,
    "beta": 89,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 583,
    "beta": 118,
    "gamma": 584
  },
  {
    "pattern": "Pisces",
    "alpha": -2,
    "beta": 2,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 65
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 41,
    "gamma": 49
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 67
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 1597,
    "gamma": 5
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.1111111111111111,
    "beta": 0.3333333333333333,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.1111111111111111,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 126,
    "gamma": 546
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 175,
    "beta": 34,
    "gamma": 175
  },
  {
    "pattern": "Andromeda",
    "alpha": 346,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 54.598150033144236,
    "beta": 7.38905609893065,
    "gamma": 148.4131591025766
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 49
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.3333333333333333,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Sagitta",
    "alpha": -8,
    "beta": 89,
    "gamma": -3
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.6931471805599453,
    "beta": 0.6931471805599453,
    "gamma": 1.0986122886681096
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 97.40909103400242,
    "beta": 31.006276680299816,
    "gamma": 306.0196847852814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 500,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.1111111111111111,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0,
    "gamma": 0.7
  },
  {
    "pattern": "Andromeda",
    "alpha": 331,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.5,
    "gamma": 0.25
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -3,
    "beta": 144,
    "gamma": 3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 120,
    "beta": 28,
    "gamma": 153
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 19
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 36,
    "beta": 6,
    "gamma": 90
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 60,
    "gamma": 468
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.6931471805599453,
    "beta": 0.6931471805599453,
    "gamma": 0.6931471805599453
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -5,
    "beta": 233,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 888,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 275,
    "gamma": 610
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -2,
    "beta": 89,
    "gamma": -2
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.5,
    "gamma": 0.015625
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 653
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.03125,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 818,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 36,
    "gamma": 630
  },
  {
    "pattern": "Crux",
    "alpha": 1091,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.3333333333333333,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -34,
    "beta": 89,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 3,
    "gamma": -2
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -18,
    "beta": 216,
    "gamma": -18
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 67
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 36,
    "gamma": 630
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.5,
    "gamma": 0.0625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 3,
    "gamma": -13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 816,
    "beta": 330,
    "gamma": 720
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 23
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.0625,
    "gamma": 0.015625
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 5,
    "gamma": -34
  },
  {
    "pattern": "Auriga",
    "alpha": 3,
    "beta": 34,
    "gamma": -55
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 13,
    "beta": 3,
    "gamma": 21
  },
  {
    "pattern": "Sagitta",
    "alpha": -8,
    "beta": 144,
    "gamma": -5
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 89,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 5,
    "beta": 377,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": -2
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 134.93203753349806,
    "beta": 7.112888999999999,
    "gamma": 134.93203753349806
  },
  {
    "pattern": "Pisces",
    "alpha": 4,
    "beta": 2,
    "gamma": 22
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 841
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 853
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 168,
    "gamma": 720
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 64,
    "beta": 8,
    "gamma": 512
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 277,
    "gamma": 610
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 3,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 6,
    "gamma": 216
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 1597,
    "gamma": 8
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 39,
    "gamma": 31
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 144,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Crux",
    "alpha": 1011,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 522,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 18,
    "gamma": 216
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 90,
    "gamma": 630
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 987,
    "gamma": -5
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 987,
    "gamma": -13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.0625,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 270,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 811,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.125,
    "gamma": 0.015625
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 13,
    "beta": 377,
    "gamma": -89
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": 3
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 11
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.012345679012345677,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cetus",
    "alpha": 1035,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 233,
    "gamma": -55
  },
  {
    "pattern": "Andromeda",
    "alpha": 270,
    "beta": 168,
    "gamma": 546
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 89,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 846
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": -8
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 3.4000000000000017
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 35
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 4.6
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 158
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 811,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.3333333333333333,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.015625,
    "gamma": 0.0625
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 27
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.012345679012345677,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 148.4131591025766,
    "beta": 20.085536923187668,
    "gamma": 148.4131591025766
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 1.2
  },
  {
    "pattern": "Pisces",
    "alpha": 7,
    "beta": 2.5,
    "gamma": 66
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 65
  },
  {
    "pattern": "Auriga",
    "alpha": 5,
    "beta": 89,
    "gamma": -144
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 891,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -8,
    "beta": 233,
    "gamma": 3
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 670
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 216,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.03703703703703703,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Crux",
    "alpha": 1083,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 854
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0,
    "gamma": 1.5000000000000002
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 31
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 186,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 51
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 34,
    "gamma": 55
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 1.6000000000000003
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": -5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 54.598150033144236,
    "beta": 20.085536923187668,
    "gamma": 148.4131591025766
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 2.9000000000000012
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 889,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.5,
    "gamma": 0.0078125
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 377,
    "gamma": 3
  },
  {
    "pattern": "Pisces",
    "alpha": 20.085536923187668,
    "beta": 7.38905609893065,
    "gamma": 148.4131591025766
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 29
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 53
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 126,
    "gamma": 468
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 216,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 632
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 13,
    "gamma": -34
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 15
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 549,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 21,
    "beta": 3,
    "gamma": 28
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 36,
    "beta": 6,
    "gamma": 126
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.1111111111111111,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 53
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 60,
    "beta": 18,
    "gamma": 270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 533,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 852
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.03125,
    "gamma": 0.5
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": -5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 148.4131591025766,
    "beta": 2.718281828459045,
    "gamma": 148.4131591025766
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 11
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Sagitta",
    "alpha": -13,
    "beta": 144,
    "gamma": -5
  },
  {
    "pattern": "Pisces",
    "alpha": 8,
    "beta": 5,
    "gamma": 55
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 27
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 329,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 36,
    "gamma": 216
  },
  {
    "pattern": "Pisces",
    "alpha": 4.31529664799597,
    "beta": 4.31529664799597,
    "gamma": 25.891779887975815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.03703703703703703,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 628
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 5,
    "gamma": -3
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.125,
    "gamma": 0.125
  },
  {
    "pattern": "Pisces",
    "alpha": -34,
    "beta": 2,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 23
  },
  {
    "pattern": "Andromeda",
    "alpha": 340,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 57
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Pisces",
    "alpha": 7,
    "beta": 7,
    "gamma": 66
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 55,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 89,
    "gamma": -8
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 55,
    "gamma": -3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 377,
    "beta": 21,
    "gamma": 377
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -8,
    "beta": 233,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 707
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 17.0859375,
    "beta": 2.25,
    "gamma": 25.62890625
  },
  {
    "pattern": "Pisces",
    "alpha": 6,
    "beta": 3,
    "gamma": 36
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Lyra",
    "alpha": 1458,
    "beta": 162,
    "gamma": 18
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 5,
    "gamma": 5
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.125,
    "gamma": 0.0625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 1.0999999999999999
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 274,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 193,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 243,
    "gamma": 610
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 3,
    "gamma": -3
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 279,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Sagitta",
    "alpha": -6,
    "beta": 168,
    "gamma": -6
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 39
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 233,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 583,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.25,
    "gamma": 0.015625
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 13,
    "gamma": 3
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 21
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 235,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": 6,
    "beta": 6,
    "gamma": 66
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 19,
    "beta": 3,
    "gamma": 50
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 126,
    "beta": 18,
    "gamma": 546
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.03125,
    "gamma": 0.015625
  },
  {
    "pattern": "Sculptor",
    "alpha": 3,
    "beta": 7.38905609893065,
    "gamma": 64
  },
  {
    "pattern": "Libra",
    "alpha": 14,
    "beta": 0,
    "gamma": 258
  },
  {
    "pattern": "Pisces",
    "alpha": 9,
    "beta": 9,
    "gamma": 81
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 11
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 21,
    "gamma": -8
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 51
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Draco",
    "alpha": 16,
    "beta": 4,
    "gamma": 484
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 256,
    "beta": 64,
    "gamma": 256
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 55,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 168,
    "gamma": 546
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -2,
    "beta": 55,
    "gamma": 3
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 67
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 890,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 53
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.3333333333333333,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 818,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.4999999999999999,
    "beta": 0.4999999999999999,
    "gamma": 1.4997597826618576
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 34,
    "gamma": -144
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 53
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.125,
    "gamma": 0.03125
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 55,
    "gamma": -55
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 63
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 23
  },
  {
    "pattern": "Andromeda",
    "alpha": 306,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 128,
    "beta": 8,
    "gamma": 512
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 817,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 45
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 41,
    "gamma": 45
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 3.600000000000002
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 41
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.03703703703703703,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.6931471805599453,
    "beta": 0.6931471805599453,
    "gamma": 1.3862943611198906
  },
  {
    "pattern": "Libra",
    "alpha": 3,
    "beta": 0,
    "gamma": 258
  },
  {
    "pattern": "Crux",
    "alpha": 630,
    "beta": 330,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": -34
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -8,
    "beta": 89,
    "gamma": 89
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 812,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Pisces",
    "alpha": -2,
    "beta": 2,
    "gamma": -34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.3333333333333333,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 610,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 696
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 60,
    "gamma": 270
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 486,
    "beta": 162,
    "gamma": 486
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 810,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 291,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": 3.375,
    "beta": 1.5,
    "gamma": 25.62890625
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 15
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 29
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 661
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 60,
    "gamma": 546
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 47
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 270,
    "gamma": 546
  },
  {
    "pattern": "Pisces",
    "alpha": 5,
    "beta": 3,
    "gamma": 34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": -2
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 36,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.03703703703703703,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.25,
    "gamma": 0.5
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 3,
    "gamma": 13
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 19
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Pisces",
    "alpha": -3,
    "beta": 3,
    "gamma": -34
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": 2
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.0625,
    "gamma": 0.0625
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 144,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 853
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 4.699999999999999
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 39,
    "gamma": 41
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 67
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 3.2000000000000015
  },
  {
    "pattern": "Sculptor",
    "alpha": 368,
    "beta": 110,
    "gamma": 176
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 11.390625,
    "beta": 3.375,
    "gamma": 25.62890625
  },
  {
    "pattern": "Pisces",
    "alpha": -5,
    "beta": 13,
    "gamma": -55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 21
  },
  {
    "pattern": "Sagitta",
    "alpha": -5,
    "beta": 144,
    "gamma": -2
  },
  {
    "pattern": "Pisces",
    "alpha": 15,
    "beta": 6,
    "gamma": 91
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 847
  },
  {
    "pattern": "Andromeda",
    "alpha": 292,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 21,
    "beta": 1597,
    "gamma": -89
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.125,
    "gamma": 0.25
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 49
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 50.59318992632099,
    "beta": 7.112888999999999,
    "gamma": 359.8637441018393
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 1,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 845
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 855
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 39,
    "gamma": 25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 853
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 126,
    "gamma": 36
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 510,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.25,
    "gamma": 0.03125
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 311,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Aquarius",
    "alpha": -36,
    "beta": 60,
    "gamma": -60
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.012345679012345677,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Aquarius",
    "alpha": -3,
    "beta": 2,
    "gamma": -13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 4.899999999999999
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.3333333333333333,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Pisces",
    "alpha": -34,
    "beta": 2,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 168,
    "gamma": 396
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 718
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 5,
    "gamma": -5
  },
  {
    "pattern": "Pisces",
    "alpha": 15,
    "beta": 15,
    "gamma": 120
  },
  {
    "pattern": "Auriga",
    "alpha": 5.0625,
    "beta": 5.0625,
    "gamma": 25.62890625
  },
  {
    "pattern": "Pisces",
    "alpha": 18.970074962999995,
    "beta": 7.112888999999999,
    "gamma": 134.93203753349806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 817,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 16
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 611
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 148.4131591025766,
    "beta": 54.598150033144236,
    "gamma": 403.4287934927351
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 2,
    "gamma": 3
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 252,
    "gamma": 610
  },
  {
    "pattern": "Andromeda",
    "alpha": 290,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 237,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 90,
    "gamma": 546
  },
  {
    "pattern": "Pisces",
    "alpha": -5,
    "beta": 5,
    "gamma": -34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.03703703703703703,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 168,
    "gamma": 546
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.012345679012345677,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -6,
    "beta": 168,
    "gamma": -36
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 2,
    "beta": 1,
    "gamma": 14
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -6,
    "beta": 126,
    "gamma": -6
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 815,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.1111111111111111,
    "beta": 0.3333333333333333,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 377,
    "gamma": 2
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 2.3000000000000007
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 21,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 60,
    "beta": 18,
    "gamma": 168
  },
  {
    "pattern": "Sculptor",
    "alpha": -5,
    "beta": 5,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 850
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 27
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -13,
    "beta": 233,
    "gamma": 21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.1111111111111111,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.5,
    "gamma": 0.03125
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 64,
    "beta": 9,
    "gamma": 169
  },
  {
    "pattern": "Aries",
    "alpha": 34,
    "beta": 3,
    "gamma": -89
  },
  {
    "pattern": "Andromeda",
    "alpha": 377,
    "beta": 377,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 987,
    "gamma": 3
  },
  {
    "pattern": "Cetus",
    "alpha": 979,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.1111111111111111,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.03703703703703703,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 0,
    "beta": 39,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.5,
    "gamma": 0.0078125
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.1111111111111111,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 28,
    "beta": 6,
    "gamma": 153
  },
  {
    "pattern": "Pisces",
    "alpha": -18,
    "beta": 6,
    "gamma": -18
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.125,
    "gamma": 0.03125
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.1111111111111111,
    "beta": 0.3333333333333333,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 8,
    "beta": 233,
    "gamma": -55
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 2,
    "beta": 1,
    "gamma": 12
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 33
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 816,
    "beta": 126,
    "gamma": 630
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 9.799999999999994
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 63
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 4,
    "gamma": 48
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 5,
    "beta": 233,
    "gamma": -233
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 120,
    "beta": 6,
    "gamma": 153
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 36,
    "gamma": 546
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 36,
    "gamma": 396
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 57
  },
  {
    "pattern": "Pisces",
    "alpha": 21,
    "beta": 20.085536923187668,
    "gamma": 128
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 680
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 3.800000000000002
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 33
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 128,
    "beta": 16,
    "gamma": 256
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 50.59318992632099,
    "beta": 18.970074962999995,
    "gamma": 134.93203753349806
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 148.4131591025766,
    "beta": 7.38905609893065,
    "gamma": 403.4287934927351
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 168,
    "gamma": 720
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 8,
    "gamma": -21
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": -2
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 33
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 168,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Sagitta",
    "alpha": -6,
    "beta": 126,
    "gamma": -18
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 57
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 27
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 43
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 269,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 176,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Aquarius",
    "alpha": -36,
    "beta": 36,
    "gamma": -36
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 319,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 987,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 506,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 126,
    "gamma": 330
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.3333333333333333,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Sagitta",
    "alpha": -5,
    "beta": 144,
    "gamma": 34
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 242,
    "gamma": 610
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 1,
    "gamma": 0.5000000000000002
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 2,
    "gamma": 2
  },
  {
    "pattern": "Pisces",
    "alpha": 3,
    "beta": 3,
    "gamma": 55
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 25,
    "beta": 4,
    "gamma": 49
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 126,
    "gamma": 270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 850
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 55
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 216,
    "beta": 6,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 39
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 686
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 216,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Lyra",
    "alpha": 1189,
    "beta": 175,
    "gamma": 73
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.5,
    "gamma": 0.25
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 2,
    "beta": 1,
    "gamma": 8.920000000000003
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.0625,
    "beta": 0.015625,
    "gamma": 0.25
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 39
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 51
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 2,
    "gamma": 37
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 35
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 29
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.012345679012345677,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.5000000000000002,
    "gamma": 1
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -8,
    "beta": 55,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.0625,
    "gamma": 0.0625
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 151
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 267,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 3,
    "gamma": 3
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.012345679012345677,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 233,
    "gamma": -55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Andromeda",
    "alpha": 336,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 61
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 684
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 41,
    "gamma": 35
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 5,
    "gamma": 57
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 258,
    "beta": 84,
    "gamma": 258
  },
  {
    "pattern": "Lyra",
    "alpha": 1140,
    "beta": 126,
    "gamma": 90
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 32,
    "beta": 2,
    "gamma": 32
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 47
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 2,
    "gamma": 8
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 3,
    "gamma": 13
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 43
  },
  {
    "pattern": "Lyra",
    "alpha": 1598,
    "beta": 377,
    "gamma": 21
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 27
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 47
  },
  {
    "pattern": "Pisces",
    "alpha": 1.5,
    "beta": 1.5,
    "gamma": 17.0859375
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 29
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.03125,
    "beta": 0.00390625,
    "gamma": 0.5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 111,
    "beta": 15,
    "gamma": 369
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 128,
    "beta": 32,
    "gamma": 512
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 5,
    "beta": 987,
    "gamma": -34
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 81,
    "beta": 9,
    "gamma": 81
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -21,
    "beta": 233,
    "gamma": 8
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.1111111111111111,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": -21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.5000000000000002,
    "gamma": 0.5000000000000001
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 294,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 90,
    "gamma": 330
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.03125,
    "beta": 0.0625,
    "gamma": 0.5
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 3,
    "gamma": 5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 2,
    "beta": 1,
    "gamma": 8.699999999999998
  },
  {
    "pattern": "Andromeda",
    "alpha": 630,
    "beta": 396,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 848
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -3
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 51
  },
  {
    "pattern": "Scorpius",
    "alpha": 2,
    "beta": 5,
    "gamma": 55
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 59
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 2,
    "gamma": 5
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 281,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 987,
    "gamma": 2
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 2,
    "gamma": -5
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.015625,
    "gamma": 0.5
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 2,
    "gamma": -2
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.4999999999999999,
    "gamma": 0.5000000000000002
  },
  {
    "pattern": "Pisces",
    "alpha": 6,
    "beta": 3,
    "gamma": 45
  },
  {
    "pattern": "Sagitta",
    "alpha": -8,
    "beta": 144,
    "gamma": 8
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 300,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 65,
    "gamma": 11
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 25
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 263,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.004115226337448558,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 90,
    "gamma": 396
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 15
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": 144
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.001371742112482853,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 3,
    "beta": 233,
    "gamma": -13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.25,
    "gamma": 0.125
  },
  {
    "pattern": "Sagitta",
    "alpha": -3,
    "beta": 144,
    "gamma": -5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 260,
    "beta": 65,
    "gamma": 369
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 854
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Pisces",
    "alpha": 4,
    "beta": 2,
    "gamma": 32
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 169,
    "beta": 64,
    "gamma": 441
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Pisces",
    "alpha": 8,
    "beta": 4,
    "gamma": 64
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 256,
    "beta": 8,
    "gamma": 512
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 244,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 271,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 15
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 8,
    "gamma": -34
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 3,
    "gamma": -2
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 3,
    "beta": 377,
    "gamma": -21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.012345679012345677,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.3333333333333333,
    "gamma": 0.0001524157902758725
  },
  {
    "pattern": "Auriga",
    "alpha": 3,
    "beta": 8,
    "gamma": -13
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 45
  },
  {
    "pattern": "Aquarius",
    "alpha": 5.0625,
    "beta": 3.375,
    "gamma": 25.62890625
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 246,
    "gamma": 610
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -8,
    "beta": 144,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 11,
    "beta": 2,
    "gamma": 22
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 36,
    "beta": 6,
    "gamma": 60
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 259,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.015625,
    "gamma": 0.125
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 310,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": 4,
    "beta": 4,
    "gamma": 37
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 11.390625,
    "beta": 2.25,
    "gamma": 25.62890625
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.125,
    "gamma": 0.125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.25,
    "gamma": 0.015625
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.015625,
    "gamma": 0.125
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 3,
    "beta": 987,
    "gamma": -13
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 11
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 11
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 90,
    "beta": 36,
    "gamma": 216
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 806,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 3,
    "beta": 1597,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 849
  },
  {
    "pattern": "Aquarius",
    "alpha": -36,
    "beta": 90,
    "gamma": -18
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 808,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 23
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 21,
    "gamma": 5
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.03125,
    "gamma": 0.125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Pisces",
    "alpha": -3,
    "beta": 2,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 60,
    "beta": 6,
    "gamma": 546
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 2.500000000000001
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 171,
    "gamma": 610
  },
  {
    "pattern": "Sculptor",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 1.4000000000000001
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 198,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.5,
    "gamma": 0.00390625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 18.970074962999995,
    "beta": 2.667,
    "gamma": 50.59318992632099
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 6.399999999999993
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.25,
    "gamma": 0.015625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 169
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.012345679012345677,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 65
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 64,
    "beta": 25,
    "gamma": 169
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.0625,
    "gamma": 0.5
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 11
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 610,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Lyra",
    "alpha": 1096.6331584284585,
    "beta": 148.4131591025766,
    "gamma": 54.598150033144236
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 5,
    "gamma": 8
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 216,
    "gamma": 468
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 25
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.03703703703703703,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 63
  },
  {
    "pattern": "Pisces",
    "alpha": 5.0625,
    "beta": 2.25,
    "gamma": 25.62890625
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 41,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 631
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 516,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 359.8637441018393,
    "beta": 134.93203753349806,
    "gamma": 359.8637441018393
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.03125,
    "gamma": 0.5
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 55
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 200,
    "gamma": 610
  },
  {
    "pattern": "Sculptor",
    "alpha": 0.25,
    "beta": 0.015625,
    "gamma": 0.25
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 7.59375,
    "beta": 1.5,
    "gamma": 17.0859375
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 13,
    "gamma": -3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 258,
    "beta": 84,
    "gamma": 399
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.3333333333333333,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 17
  },
  {
    "pattern": "Andromeda",
    "alpha": 287,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 377,
    "gamma": 2
  },
  {
    "pattern": "Andromeda",
    "alpha": 378,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 852
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.5,
    "gamma": 0.125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 3,
    "beta": 233,
    "gamma": -34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.03703703703703703,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 19
  },
  {
    "pattern": "Sagitta",
    "alpha": -3,
    "beta": 89,
    "gamma": -5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 848
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 134.93203753349806,
    "beta": 2.667,
    "gamma": 134.93203753349806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 895,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 11,
    "beta": 2,
    "gamma": 29
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 41,
    "gamma": 47
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 3,
    "beta": 144,
    "gamma": -13
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 25
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 71
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 13,
    "beta": 3,
    "gamma": 55
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 126,
    "gamma": 330
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 155,
    "beta": 84,
    "gamma": 258
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 817,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.004115226337448558,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 812,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 987,
    "gamma": -5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 16,
    "beta": 4,
    "gamma": 29
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.125,
    "gamma": 0.25
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -3,
    "beta": 89,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 19
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.03703703703703703,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 987,
    "gamma": -21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 846
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 3,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 815,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 35
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 126,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 270,
    "gamma": 630
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.5,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 584,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 610,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -13,
    "beta": 144,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Lyra",
    "alpha": 1140,
    "beta": 168,
    "gamma": 216
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 813,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Sculptor",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 1.3
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 126,
    "beta": 90,
    "gamma": 468
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 377,
    "beta": 89,
    "gamma": 377
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 502,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 216,
    "gamma": 630
  },
  {
    "pattern": "Crux",
    "alpha": 987,
    "beta": 377,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 126,
    "beta": 6,
    "gamma": 330
  },
  {
    "pattern": "Pisces",
    "alpha": -34,
    "beta": 2,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 21
  },
  {
    "pattern": "Auriga",
    "alpha": 13,
    "beta": 55,
    "gamma": -89
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 9.599999999999994
  },
  {
    "pattern": "Pisces",
    "alpha": -8,
    "beta": 3,
    "gamma": -21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 59
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 233,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Pisces",
    "alpha": 18,
    "beta": 6,
    "gamma": 126
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 34,
    "beta": 8,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 60,
    "gamma": 468
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 36,
    "gamma": 270
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 23
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 8,
    "beta": 233,
    "gamma": -34
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 65
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Sagitta",
    "alpha": -8,
    "beta": 144,
    "gamma": 13
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -8,
    "beta": 144,
    "gamma": -2
  },
  {
    "pattern": "Sagitta",
    "alpha": -5,
    "beta": 89,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.5,
    "gamma": 0.0625
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -8,
    "beta": 233,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 852
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 128,
    "beta": 2,
    "gamma": 128
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 546,
    "gamma": 816
  },
  {
    "pattern": "Pisces",
    "alpha": 4,
    "beta": 2,
    "gamma": 29
  },
  {
    "pattern": "Pisces",
    "alpha": -55,
    "beta": 2,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.03703703703703703,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -233
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 18,
    "gamma": 270
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 1.2
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -6,
    "beta": 216,
    "gamma": -6
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 90,
    "gamma": 396
  },
  {
    "pattern": "Lyra",
    "alpha": 1140,
    "beta": 126,
    "gamma": 126
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.125,
    "gamma": 0.125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 168,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 41
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 2,
    "gamma": 3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 126,
    "gamma": 546
  },
  {
    "pattern": "Pisces",
    "alpha": 3,
    "beta": 3,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 643
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 6,
    "gamma": 468
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 55,
    "gamma": 89
  },
  {
    "pattern": "Andromeda",
    "alpha": 322,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 3,
    "gamma": -13
  },
  {
    "pattern": "Pisces",
    "alpha": 3,
    "beta": 3,
    "gamma": 39
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 29,
    "beta": 2,
    "gamma": 37
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 5.0625,
    "beta": 1.5,
    "gamma": 11.390625
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 21,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 815,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 55,
    "gamma": -89
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 849
  },
  {
    "pattern": "Leo",
    "alpha": 2,
    "beta": 1,
    "gamma": 50
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 41,
    "gamma": 29
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 890,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 216,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 57
  },
  {
    "pattern": "Andromeda",
    "alpha": 332,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 2,
    "gamma": 34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Libra",
    "alpha": 3,
    "beta": 0,
    "gamma": 84
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.125,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 887,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 503,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 167,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 47
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 1.0999999999999999
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 8,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 846
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 49
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 19
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 63
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 359.8637441018393,
    "beta": 50.59318992632099,
    "gamma": 359.8637441018393
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 987,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 11
  },
  {
    "pattern": "Andromeda",
    "alpha": 309,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 21,
    "beta": 2,
    "gamma": 21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 90,
    "gamma": 546
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -6,
    "beta": 168,
    "gamma": -18
  },
  {
    "pattern": "Cetus",
    "alpha": 918,
    "beta": 630,
    "gamma": 720
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 855
  },
  {
    "pattern": "Cetus",
    "alpha": 918,
    "beta": 168,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 806,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": 13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 169,
    "beta": 25,
    "gamma": 441
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 216,
    "beta": 6,
    "gamma": 330
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 658
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 534,
    "gamma": 819
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 41
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 90,
    "gamma": 330
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 817,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 144,
    "gamma": 8
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 377,
    "gamma": -8
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 3,
    "beta": 55,
    "gamma": -13
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 633
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 216,
    "gamma": 630
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 15
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 2,
    "gamma": 3
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 3,
    "gamma": -5
  },
  {
    "pattern": "Sculptor",
    "alpha": 370,
    "beta": 111,
    "gamma": 175
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 19
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 0.2
  },
  {
    "pattern": "Draco",
    "alpha": 16,
    "beta": 4,
    "gamma": 529
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Sculptor",
    "alpha": 368,
    "beta": 110,
    "gamma": 177
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": 5
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 14,
    "beta": 3,
    "gamma": 84
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 15
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 250,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 399,
    "beta": 155,
    "gamma": 399
  },
  {
    "pattern": "Andromeda",
    "alpha": 348,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 54.598150033144236,
    "beta": 1,
    "gamma": 54.598150033144236
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 18,
    "gamma": 396
  },
  {
    "pattern": "Scorpius",
    "alpha": 3,
    "beta": 5,
    "gamma": 34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 845
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 216,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Auriga",
    "alpha": -8,
    "beta": 34,
    "gamma": 34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 2,
    "gamma": -2
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.012345679012345677,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 144,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 126,
    "gamma": 468
  },
  {
    "pattern": "Pisces",
    "alpha": -5,
    "beta": 3,
    "gamma": -21
  },
  {
    "pattern": "Andromeda",
    "alpha": 339,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 1,
    "gamma": 0.5000000000000001
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 217,
    "gamma": 610
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.004115226337448558,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.5,
    "gamma": 0.0078125
  },
  {
    "pattern": "Scorpius",
    "alpha": 2,
    "beta": 5,
    "gamma": 50
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 243,
    "beta": 81,
    "gamma": 243
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cetus",
    "alpha": 918,
    "beta": 126,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 535,
    "gamma": 819
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 55,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.3333333333333333,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 126,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.3333333333333333,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 55
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 4.200000000000001
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.5,
    "gamma": 0.0625
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 673
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 34,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 6,
    "gamma": 468
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 2.500000000000001
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 21,
    "gamma": 34
  },
  {
    "pattern": "Andromeda",
    "alpha": 317,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Sculptor",
    "alpha": 368,
    "beta": 109,
    "gamma": 175
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 584,
    "beta": 118,
    "gamma": 583
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Crux",
    "alpha": 955,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 548,
    "gamma": 819
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 377,
    "gamma": -987
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.5,
    "gamma": 0.25
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 168,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 987,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.25,
    "gamma": 0.00390625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 5,
    "gamma": -21
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 256,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 266,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 65,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 211,
    "gamma": 610
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 634
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Pisces",
    "alpha": -34,
    "beta": 3,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 856
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Lyra",
    "alpha": 1140,
    "beta": 168,
    "gamma": 168
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 32,
    "beta": 4,
    "gamma": 128
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 563,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 403.4287934927351,
    "beta": 2.718281828459045,
    "gamma": 403.4287934927351
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 201,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 27
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 39
  },
  {
    "pattern": "Andromeda",
    "alpha": 349,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 270,
    "gamma": 720
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 295,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 57
  },
  {
    "pattern": "Lyra",
    "alpha": 1026,
    "beta": 90,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.012345679012345677,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 233,
    "beta": 144,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 126,
    "gamma": 330
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 51
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 125,
    "beta": 27,
    "gamma": 125
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.25,
    "gamma": 0.125
  },
  {
    "pattern": "Andromeda",
    "alpha": 323,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": -5
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 377,
    "gamma": -8
  },
  {
    "pattern": "Andromeda",
    "alpha": 277,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 857
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Andromeda",
    "alpha": 304,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Auriga",
    "alpha": 2,
    "beta": 21,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.015625,
    "beta": 0.00390625,
    "gamma": 0.5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 168,
    "gamma": 630
  },
  {
    "pattern": "Pisces",
    "alpha": 8,
    "beta": 3,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Sculptor",
    "alpha": -3,
    "beta": 5,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 544,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 500,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 59
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 168
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 377,
    "beta": 5,
    "gamma": 377
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 1597,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 2,
    "beta": 1,
    "gamma": 7
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 285,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 39,
    "gamma": 11
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 820,
    "beta": 118,
    "gamma": 585
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 41,
    "gamma": 21
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 61
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 0.4999999999999999,
    "gamma": 0
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 2,
    "gamma": 22
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Lyra",
    "alpha": 1189,
    "beta": 175,
    "gamma": 52
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 63
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 2,
    "gamma": -5
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 644
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.012345679012345677,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 36,
    "beta": 6,
    "gamma": 216
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Andromeda",
    "alpha": 276,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 27
  },
  {
    "pattern": "Andromeda",
    "alpha": 300,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 846
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 41
  },
  {
    "pattern": "Lyra",
    "alpha": 987,
    "beta": 144,
    "gamma": -987
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 90,
    "gamma": 468
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 3,
    "gamma": 21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 216,
    "gamma": 720
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 987,
    "gamma": -8
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 270,
    "gamma": 546
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 35
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 27
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 288,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.4999999999999999,
    "gamma": 0.4999999999999999
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 849
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 29
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 15
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 21,
    "gamma": -55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 165
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 377,
    "gamma": -610
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 64,
    "beta": 4,
    "gamma": 128
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 126,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.3333333333333333,
    "beta": 0.3333333333333333,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Pisces",
    "alpha": -8,
    "beta": 2,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 854
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 97.40909103400242,
    "beta": 9.869604401089358,
    "gamma": 306.0196847852814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -5,
    "beta": 144,
    "gamma": -3
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.1111111111111111,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.5,
    "gamma": 0.0625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 539,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Andromeda",
    "alpha": 296,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 47
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.6931471805599453,
    "beta": 0.6931471805599453,
    "gamma": 2.1972245773362196
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.5,
    "gamma": 0.25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 33
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.1111111111111111,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 57
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 219,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 543,
    "gamma": 819
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 34,
    "gamma": -2
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.0078125,
    "beta": 0.0078125,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 164
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 23
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Sculptor",
    "alpha": 375,
    "beta": 111,
    "gamma": 175
  },
  {
    "pattern": "Andromeda",
    "alpha": 338,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 25
  },
  {
    "pattern": "Andromeda",
    "alpha": 325,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.25,
    "beta": 0.5,
    "gamma": 0.0625
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.015625,
    "gamma": 0.25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 13,
    "gamma": -34
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 5,
    "beta": 987,
    "gamma": -21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.0625,
    "gamma": 0.25
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 639
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 49
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.1111111111111111,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 29
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 55,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 672
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 610,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 2,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 2,
    "gamma": -34
  },
  {
    "pattern": "Crux",
    "alpha": 995,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 1026,
    "beta": 546,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 507,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 814,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 3,
    "beta": 377,
    "gamma": -13
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 27
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 0.9999999999999999
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 216,
    "gamma": 546
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": 13
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 15
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 0.30000000000000004
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 3.0000000000000013
  },
  {
    "pattern": "Crux",
    "alpha": 1026,
    "beta": 396,
    "gamma": 630
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 847
  },
  {
    "pattern": "Sculptor",
    "alpha": 374,
    "beta": 111,
    "gamma": 175
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 3,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 302,
    "gamma": 610
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 652
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Pisces",
    "alpha": 28,
    "beta": 15,
    "gamma": 153
  },
  {
    "pattern": "Sculptor",
    "alpha": 378,
    "beta": 111,
    "gamma": 175
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 524,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Andromeda",
    "alpha": 468,
    "beta": 330,
    "gamma": 630
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 25
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 17
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 31
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 0
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 34,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.3333333333333333,
    "gamma": 0.0001524157902758725
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 10,
    "beta": 3,
    "gamma": 21
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 396,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 888,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 441,
    "beta": 25,
    "gamma": 441
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.25,
    "gamma": 0.0078125
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.015625,
    "gamma": 0.25
  },
  {
    "pattern": "Pisces",
    "alpha": -2,
    "beta": 3,
    "gamma": -34
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 66,
    "beta": 6,
    "gamma": 120
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 65
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 720,
    "beta": 468,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 19
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 327,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 815,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 257,
    "gamma": 610
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -13,
    "beta": 144,
    "gamma": -144
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Pisces",
    "alpha": -34,
    "beta": 2,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 855
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Andromeda",
    "alpha": 302,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 811,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 13,
    "beta": 610,
    "gamma": -55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 31
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 13
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 377,
    "gamma": -2
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 32,
    "beta": 4,
    "gamma": 64
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 167
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 4.999999999999998
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 27
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 545,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 128,
    "beta": 8,
    "gamma": 128
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 144,
    "beta": 89,
    "gamma": 377
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 39,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 843
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 3.1000000000000014
  },
  {
    "pattern": "Sculptor",
    "alpha": -3,
    "beta": 3,
    "gamma": 13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.3333333333333333,
    "gamma": 0.0001524157902758725
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Pisces",
    "alpha": 1.5,
    "beta": 1.5,
    "gamma": 25.62890625
  },
  {
    "pattern": "Pisces",
    "alpha": 9.869604401089358,
    "beta": 9.869604401089358,
    "gamma": 97.40909103400242
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 49
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 3.5000000000000018
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 39
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 1.4000000000000001
  },
  {
    "pattern": "Sculptor",
    "alpha": 368,
    "beta": 110,
    "gamma": 178
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -6,
    "beta": 168,
    "gamma": -168
  },
  {
    "pattern": "Andromeda",
    "alpha": 311,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -21,
    "beta": 34,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Aquarius",
    "alpha": -3,
    "beta": 13,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 256,
    "beta": 8,
    "gamma": 256
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": -233
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 9.499999999999995
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 236,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 270,
    "gamma": 720
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 15
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 813,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 811,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -2,
    "beta": 144,
    "gamma": 5
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.125,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.25,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 841
  },
  {
    "pattern": "Auriga",
    "alpha": 3,
    "beta": 89,
    "gamma": -144
  },
  {
    "pattern": "Auriga",
    "alpha": 2,
    "beta": 2,
    "gamma": 11
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 49
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0,
    "beta": 1,
    "gamma": 0
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 126,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 2,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 681
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.3333333333333333,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 126,
    "gamma": 630
  },
  {
    "pattern": "Aquarius",
    "alpha": -3,
    "beta": 8,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.001371742112482853,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 720,
    "beta": 468,
    "gamma": 720
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 887,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.3333333333333333,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Andromeda",
    "alpha": 291,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 90,
    "gamma": 546
  },
  {
    "pattern": "Sculptor",
    "alpha": 0.25,
    "beta": 0.0625,
    "gamma": 0.25
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 2.3000000000000007
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 34,
    "beta": 3,
    "gamma": 34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 610,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 2,
    "gamma": -2
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 43
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.1111111111111111,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 21,
    "beta": 3,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Auriga",
    "alpha": -8,
    "beta": 21,
    "gamma": 21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 128,
    "beta": 32,
    "gamma": 256
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Crux",
    "alpha": 816,
    "beta": 216,
    "gamma": 720
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 377,
    "beta": 89,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0,
    "beta": 1,
    "gamma": 1
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 57
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 1597,
    "gamma": -8
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 36,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Lyra",
    "alpha": 1140,
    "beta": 90,
    "gamma": 60
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.004115226337448558,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 63
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 59
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 90,
    "beta": 6,
    "gamma": 126
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.25,
    "gamma": 0.03125
  },
  {
    "pattern": "Auriga",
    "alpha": 3,
    "beta": 55,
    "gamma": -89
  },
  {
    "pattern": "Pisces",
    "alpha": -8,
    "beta": 2,
    "gamma": -34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.3333333333333333,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 25
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 175,
    "beta": 15,
    "gamma": 369
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 51
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 61
  },
  {
    "pattern": "Andromeda",
    "alpha": 280,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 377,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 531,
    "gamma": 819
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 60,
    "beta": 6,
    "gamma": 126
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 144,
    "gamma": -55
  },
  {
    "pattern": "Andromeda",
    "alpha": 294,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 37
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 5,
    "beta": 233,
    "gamma": -55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.125,
    "gamma": 0.0078125
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 35
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 144,
    "gamma": -89
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 55,
    "gamma": -21
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 1,
    "gamma": 0.4999999999999999
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 808,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.015625,
    "gamma": 0.0625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Pisces",
    "alpha": 9,
    "beta": 4,
    "gamma": 64
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Andromeda",
    "alpha": 319,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 3.700000000000002
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -3,
    "beta": 55,
    "gamma": 3
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.5,
    "gamma": 0.03125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Pisces",
    "alpha": 16,
    "beta": 8,
    "gamma": 128
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 163,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.004115226337448558,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 19
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.3333333333333333,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 8,
    "gamma": -13
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 221,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -34,
    "beta": 89,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.25,
    "gamma": 0.03125
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 399,
    "beta": 84,
    "gamma": 399
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 537,
    "gamma": 819
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 13
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 34,
    "gamma": 34
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 150
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 2,
    "beta": 55,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 11.390625,
    "beta": 1.5,
    "gamma": 17.0859375
  },
  {
    "pattern": "Lyra",
    "alpha": 1599,
    "beta": 377,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cetus",
    "alpha": 987,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 667
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.03125,
    "gamma": 0.015625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 854
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.3333333333333333,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 326,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 685
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 306.0196847852814,
    "beta": 97.40909103400242,
    "gamma": 306.0196847852814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 27
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 889,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 3,
    "gamma": 3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 39
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 111,
    "beta": 34,
    "gamma": 260
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 809,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Virgo",
    "alpha": 0,
    "beta": 3,
    "gamma": 39
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 47
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.3333333333333333,
    "beta": 0.3333333333333333,
    "gamma": 0.0001524157902758725
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 43,
    "gamma": 19
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 987,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 509,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.3333333333333333,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 69
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.0078125,
    "gamma": 0.25
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -6,
    "beta": 216,
    "gamma": -18
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 228,
    "gamma": 610
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 312,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.3333333333333333,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 2,
    "gamma": 13
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.0078125,
    "beta": 0.015625,
    "gamma": 0.5
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 2,
    "beta": 89,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Sagitta",
    "alpha": -2,
    "beta": 144,
    "gamma": -8
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 220,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 715
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 818,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 377,
    "gamma": -13
  },
  {
    "pattern": "Andromeda",
    "alpha": 216,
    "beta": 168,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 234,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.3333333333333333,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Scorpius",
    "alpha": 2,
    "beta": 4,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.3333333333333333,
    "gamma": 0.0001524157902758725
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 853
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 36,
    "gamma": 330
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 35
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 29,
    "beta": 2,
    "gamma": 29
  },
  {
    "pattern": "Scorpius",
    "alpha": 2,
    "beta": 3,
    "gamma": 21
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 3,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.25,
    "gamma": 0.00390625
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -8,
    "beta": 233,
    "gamma": 13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 66,
    "beta": 2.5,
    "gamma": 66
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 25
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 270,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.5000000000000002,
    "gamma": 0.4999999999999999
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 22,
    "beta": 4,
    "gamma": 29
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 3,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 187.91462850239847,
    "beta": 50.75401951173493,
    "gamma": 187.91462850239847
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 144,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 890,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.5,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 43
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 34,
    "gamma": 5
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 59
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 36,
    "gamma": 168
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.03703703703703703,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 542,
    "gamma": 819
  },
  {
    "pattern": "Pisces",
    "alpha": -3,
    "beta": 2,
    "gamma": -21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 90,
    "gamma": 468
  },
  {
    "pattern": "Pisces",
    "alpha": 8,
    "beta": 7.38905609893065,
    "gamma": 64
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 39
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.00390625,
    "beta": 0.015625,
    "gamma": 0.015625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 61
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 849
  },
  {
    "pattern": "Aries",
    "alpha": 55,
    "beta": 8,
    "gamma": -144
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 853
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 583,
    "beta": 118,
    "gamma": 583
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 90,
    "gamma": 330
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 0.4
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.0625,
    "gamma": 0.0078125
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 36,
    "gamma": 270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 5,
    "gamma": -2
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 34,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": -5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 2,
    "beta": 1,
    "gamma": 8.910000000000002
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 847
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 36,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 1597,
    "gamma": -8
  },
  {
    "pattern": "Sagitta",
    "alpha": -18,
    "beta": 162,
    "gamma": 18
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Sagitta",
    "alpha": -3,
    "beta": 233,
    "gamma": -55
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 51
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.012345679012345677,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 3.900000000000002
  },
  {
    "pattern": "Andromeda",
    "alpha": 299,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 849
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 61
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 55,
    "gamma": -89
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 842
  },
  {
    "pattern": "Pisces",
    "alpha": 3.141592653589793,
    "beta": 3.141592653589793,
    "gamma": 31.006276680299816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 918,
    "beta": 720,
    "gamma": 720
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 25
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 126,
    "gamma": 546
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 0,
    "beta": 258,
    "gamma": 0
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.25,
    "gamma": 0.00390625
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 126,
    "beta": 6,
    "gamma": 216
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 89,
    "beta": 5,
    "gamma": 89
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 840
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Pisces",
    "alpha": 2.453701991420671,
    "beta": 2.453701991420671,
    "gamma": 23.140692632779267
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 6,
    "gamma": 396
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 39,
    "gamma": 39
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 19
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.6931471805599453,
    "beta": 0.6931471805599453,
    "gamma": 1.791759469228055
  },
  {
    "pattern": "Aquarius",
    "alpha": -36,
    "beta": 90,
    "gamma": -36
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 49
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 894,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Draco",
    "alpha": 18,
    "beta": 6,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 60,
    "gamma": 546
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 5,
    "beta": 377,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 157
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 848
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 703
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 57
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 255,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 206,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 847
  },
  {
    "pattern": "Andromeda",
    "alpha": 377,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 5,
    "beta": 144,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 878,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.25,
    "beta": 0.5,
    "gamma": 0.03125
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 6,
    "gamma": 270
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 126,
    "gamma": 468
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 28,
    "beta": 3,
    "gamma": 36
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 233,
    "gamma": -13
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.03125,
    "gamma": 0.03125
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 29,
    "beta": 4,
    "gamma": 37
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 45
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 60,
    "gamma": 630
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 5,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Pisces",
    "alpha": -2,
    "beta": 2,
    "gamma": -21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 27
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Pisces",
    "alpha": 3,
    "beta": 3,
    "gamma": 27
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 90,
    "gamma": 396
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 230,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 816,
    "beta": 60,
    "gamma": 546
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 1.9000000000000006
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 1597,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 144,
    "gamma": 21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.3333333333333333,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 47,
    "gamma": 23
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.1111111111111111,
    "beta": 0.3333333333333333,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Gemini Seed",
    "alpha": -3,
    "beta": 144,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 2,
    "gamma": 21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.25,
    "gamma": 0.125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 855
  },
  {
    "pattern": "Crux",
    "alpha": 947,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 546,
    "beta": 6,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 35
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 34,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Auriga",
    "alpha": -6,
    "beta": 36,
    "gamma": -60
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 65,
    "beta": 5,
    "gamma": 175
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": -55
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 55
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 216,
    "beta": 18,
    "gamma": 468
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 19
  },
  {
    "pattern": "Aquarius",
    "alpha": -3,
    "beta": 2,
    "gamma": -5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 126,
    "gamma": 330
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 64,
    "beta": 8,
    "gamma": 128
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 239,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 13,
    "beta": 2,
    "gamma": 21
  },
  {
    "pattern": "Andromeda",
    "alpha": 345,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 17
  },
  {
    "pattern": "Pisces",
    "alpha": 1,
    "beta": 1,
    "gamma": 20.085536923187668
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.5,
    "beta": 0.25,
    "gamma": 0.015625
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 39,
    "gamma": 29
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 710
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 55,
    "gamma": -5
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 152
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.3333333333333333,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 849,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 23
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 3,
    "gamma": -8
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 546,
    "gamma": 720
  },
  {
    "pattern": "Pisces",
    "alpha": 1.5,
    "beta": 2.25,
    "gamma": 25.62890625
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.03125,
    "gamma": 0.03125
  },
  {
    "pattern": "Sculptor",
    "alpha": 486,
    "beta": 162,
    "gamma": 162
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 53
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 31.006276680299816,
    "beta": 3.141592653589793,
    "gamma": 31.006276680299816
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 2,
    "gamma": -3
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.1111111111111111,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 811,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.3333333333333333,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 21,
    "gamma": 34
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 23
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 29
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 34,
    "beta": 5,
    "gamma": 260
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 27
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 179,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 1,
    "gamma": 15
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 134.93203753349806,
    "beta": 18.970074962999995,
    "gamma": 359.8637441018393
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 60,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 5,
    "gamma": 21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 35
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 67
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 36,
    "gamma": 168
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 2,
    "beta": 34,
    "gamma": -8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 11
  },
  {
    "pattern": "Scorpius",
    "alpha": 2,
    "beta": 5,
    "gamma": 53
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Crux",
    "alpha": 1019,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 851
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 111,
    "beta": 15,
    "gamma": 260
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": 3
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 59
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 13,
    "beta": 2,
    "gamma": 34
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 8,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.03125,
    "gamma": 0.0625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 89,
    "beta": 987,
    "gamma": -377
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 23
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.03703703703703703,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 889,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 36,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 47
  },
  {
    "pattern": "Auriga",
    "alpha": -8,
    "beta": 55,
    "gamma": -89
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 876,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 818,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 854
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 13
  },
  {
    "pattern": "Aquarius",
    "alpha": -36,
    "beta": 36,
    "gamma": -6
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 850
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 881,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.25,
    "gamma": 0.25
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 90,
    "gamma": 468
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 13,
    "gamma": -21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 369,
    "beta": 15,
    "gamma": 369
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 90,
    "beta": 6,
    "gamma": 330
  },
  {
    "pattern": "Draco",
    "alpha": 7.38905609893065,
    "beta": 2.718281828459045,
    "gamma": 403.4287934927351
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.5,
    "gamma": 0.03125
  },
  {
    "pattern": "Cetus",
    "alpha": 1026,
    "beta": 168,
    "gamma": 630
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 35
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 851
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 584,
    "gamma": 820
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Auriga",
    "alpha": -13,
    "beta": 34,
    "gamma": 21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 29
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 867,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Andromeda",
    "alpha": 330,
    "beta": 270,
    "gamma": 630
  },
  {
    "pattern": "Libra",
    "alpha": 14,
    "beta": 0,
    "gamma": 399
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 216,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 810,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 89,
    "beta": 21,
    "gamma": 377
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Auriga",
    "alpha": 2,
    "beta": 34,
    "gamma": -55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.3333333333333333,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 233,
    "gamma": 233
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 21,
    "beta": 233,
    "gamma": -89
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 90,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 547,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.3333333333333333,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 848
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 11
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 84,
    "beta": 14,
    "gamma": 399
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 21,
    "gamma": 21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.25,
    "beta": 0.5,
    "gamma": 0.0078125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 808,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Andromeda",
    "alpha": 314,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": 5
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 37
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 175,
    "beta": 15,
    "gamma": 175
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.03125,
    "gamma": 0.125
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 65,
    "gamma": 27
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 182,
    "gamma": 610
  },
  {
    "pattern": "Andromeda",
    "alpha": 307,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 45
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 676
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 60,
    "beta": 6,
    "gamma": 216
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 2,
    "gamma": 2
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 0,
    "beta": 14,
    "gamma": 0
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.6931471805599453,
    "beta": 0.6931471805599453,
    "gamma": 1.9459101490553132
  },
  {
    "pattern": "Andromeda",
    "alpha": 295,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 585,
    "beta": 118,
    "gamma": 584
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 166,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 705
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 813,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.3333333333333333,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 2.0000000000000004
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 841
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 256,
    "beta": 64,
    "gamma": 512
  },
  {
    "pattern": "Pisces",
    "alpha": -5,
    "beta": 2,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.1111111111111111,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 34,
    "gamma": 34
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 134.93203753349806,
    "beta": 18.970074962999995,
    "gamma": 134.93203753349806
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 55
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.03125,
    "gamma": 0.5
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 719
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Sculptor",
    "alpha": 0,
    "beta": 0.5000000000000001,
    "gamma": 1.4997597826618576
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Scorpius",
    "alpha": 28,
    "beta": 3,
    "gamma": 28
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.3333333333333333,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.4999999999999999,
    "beta": 1,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 49
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 64,
    "beta": 8,
    "gamma": 256
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 23
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 126,
    "beta": 6,
    "gamma": 468
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 525,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 855
  },
  {
    "pattern": "Lyra",
    "alpha": 816,
    "beta": 60,
    "gamma": 630
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.3333333333333333,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 0,
    "beta": 399,
    "gamma": 0
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.4999999999999999,
    "beta": 0.4999999999999999,
    "gamma": 0
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.1111111111111111,
    "beta": 0.3333333333333333,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 173,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 168,
    "gamma": 468
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 55,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 233,
    "gamma": 34
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0,
    "beta": 1,
    "gamma": 0.5000000000000002
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 39
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 18,
    "gamma": 168
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 713
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 8,
    "gamma": 8
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 3.700000000000002
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 41,
    "gamma": 21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 162,
    "beta": 54,
    "gamma": 486
  },
  {
    "pattern": "Andromeda",
    "alpha": 298,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -13,
    "beta": 233,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 11.390625,
    "beta": 1.5,
    "gamma": 25.62890625
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 53
  },
  {
    "pattern": "Auriga",
    "alpha": 5,
    "beta": 21,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.5,
    "gamma": 0.015625
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 8,
    "beta": 2,
    "gamma": 21
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 11
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 1.9000000000000006
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 3,
    "gamma": -2
  },
  {
    "pattern": "Crux",
    "alpha": 1026,
    "beta": 216,
    "gamma": 630
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 151,
    "beta": 15,
    "gamma": 260
  },
  {
    "pattern": "Gemini Seed",
    "alpha": 2,
    "beta": 144,
    "gamma": -21
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 60,
    "beta": 6,
    "gamma": 468
  },
  {
    "pattern": "Andromeda",
    "alpha": 288,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 610,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 720,
    "beta": 270,
    "gamma": 630
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 41,
    "gamma": 51
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 806,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 721
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 63
  },
  {
    "pattern": "Crux",
    "alpha": 923,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 17.0859375,
    "beta": 1.5,
    "gamma": 25.62890625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Sagitta",
    "alpha": -8,
    "beta": 144,
    "gamma": -8
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 45
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 59
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 39
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 203,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 59
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 61
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 882,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 809,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 301,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 801,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.03125,
    "gamma": 0.5
  },
  {
    "pattern": "Aquarius",
    "alpha": -34,
    "beta": 21,
    "gamma": -5
  },
  {
    "pattern": "Leo",
    "alpha": 2,
    "beta": 1,
    "gamma": 46
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 803
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.03703703703703703,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.0625,
    "gamma": 0.25
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 36,
    "gamma": 396
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 8,
    "gamma": -21
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 2.600000000000001
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 814,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.25,
    "gamma": 0.03125
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 303,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 36,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 808,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 41,
    "gamma": 29
  },
  {
    "pattern": "Pisces",
    "alpha": 3.375,
    "beta": 1.5,
    "gamma": 17.0859375
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Andromeda",
    "alpha": 335,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 43,
    "gamma": 11
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 839
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 3,
    "gamma": 5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 216,
    "gamma": 468
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 610,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 832,
    "beta": 578,
    "gamma": 852
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 41,
    "gamma": 49
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 53
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.0078125,
    "gamma": 0.5
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0,
    "beta": 1,
    "gamma": 0.4999999999999999
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 859,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 162,
    "beta": 18,
    "gamma": 486
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 45
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 692
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 34,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 599,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.012345679012345677,
    "beta": 0.3333333333333333,
    "gamma": 0.03703703703703703
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 2,
    "gamma": 48
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 1597,
    "gamma": -13
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 144,
    "gamma": 2
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 53,
    "gamma": 55
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 377,
    "gamma": -21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 89,
    "gamma": -89
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.3333333333333333,
    "gamma": 0.00045724737082761756
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.03703703703703703,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Pisces",
    "alpha": -5,
    "beta": 2,
    "gamma": -21
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 60,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 35
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 25,
    "beta": 4,
    "gamma": 36
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 869,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 8,
    "gamma": -5
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 126,
    "gamma": 90
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 39,
    "gamma": 43
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 36,
    "beta": 6,
    "gamma": 168
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 2,
    "beta": 144,
    "gamma": -34
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 1.7000000000000004
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 468,
    "beta": 126,
    "gamma": 546
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 841
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 318,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 50.59318992632099,
    "beta": 2.667,
    "gamma": 50.59318992632099
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 21,
    "beta": 987,
    "gamma": -89
  },
  {
    "pattern": "Lepus",
    "alpha": 1,
    "beta": 0.5000000000000001,
    "gamma": 1.4997597826618576
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0,
    "gamma": 1.2
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -18,
    "beta": 162,
    "gamma": -18
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 65,
    "beta": 5,
    "gamma": 369
  },
  {
    "pattern": "Aquarius",
    "alpha": -3,
    "beta": 21,
    "gamma": -55
  },
  {
    "pattern": "Lyra",
    "alpha": 987,
    "beta": 233,
    "gamma": -987
  },
  {
    "pattern": "Scorpius",
    "alpha": 2,
    "beta": 5,
    "gamma": 51
  },
  {
    "pattern": "Sculptor",
    "alpha": 216,
    "beta": 90,
    "gamma": 216
  },
  {
    "pattern": "Aquarius",
    "alpha": -18,
    "beta": 6,
    "gamma": -6
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 55
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 15,
    "beta": 3,
    "gamma": 45
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 39,
    "gamma": 29
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 3,
    "beta": 89,
    "gamma": -21
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 615
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 4.4
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 29
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 1597,
    "gamma": -21
  },
  {
    "pattern": "Lyra",
    "alpha": 1126,
    "beta": 109,
    "gamma": 52
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 2.800000000000001
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 645
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 233,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 853,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 821,
    "beta": 578,
    "gamma": 822
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.5,
    "gamma": 0.00390625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.3333333333333333,
    "gamma": 0.0001524157902758725
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 5,
    "gamma": -8
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 706
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 871,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 45,
    "beta": 6,
    "gamma": 120
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 16,
    "beta": 2,
    "gamma": 22
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 2,
    "beta": 1,
    "gamma": 8.905000000000001
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.3333333333333333,
    "gamma": 0.001371742112482853
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 2,
    "gamma": -34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 811,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -5,
    "beta": 144,
    "gamma": -13
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 89,
    "gamma": -3
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 810,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 168,
    "beta": 18,
    "gamma": 546
  },
  {
    "pattern": "Pisces",
    "alpha": 4,
    "beta": 9,
    "gamma": 121
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 164,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 853
  },
  {
    "pattern": "Andromeda",
    "alpha": 312,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 1597,
    "gamma": -3
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 55,
    "gamma": -2
  },
  {
    "pattern": "Aquarius",
    "alpha": -21,
    "beta": 21,
    "gamma": -2
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 63,
    "gamma": 29
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 36,
    "gamma": 216
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 846,
    "beta": 578,
    "gamma": 831
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 850
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.1111111111111111,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 18,
    "gamma": 396
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 69
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 687
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 37,
    "beta": 2,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 839,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Andromeda",
    "alpha": 308,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 610,
    "gamma": -8
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 27,
    "beta": 3,
    "gamma": 81
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 889,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 63
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 8,
    "beta": 2,
    "gamma": 34
  },
  {
    "pattern": "Pisces",
    "alpha": 9.869604401089358,
    "beta": 3.141592653589793,
    "gamma": 97.40909103400242
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0625,
    "beta": 0.0625,
    "gamma": 0.25
  },
  {
    "pattern": "Sculptor",
    "alpha": 0.25,
    "beta": 0.00390625,
    "gamma": 0.25
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 11
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 678
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.1111111111111111,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 892,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 2.400000000000001
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 187,
    "gamma": 610
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 55,
    "gamma": -2
  },
  {
    "pattern": "Pisces",
    "alpha": -21,
    "beta": 8,
    "gamma": -2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 47
  },
  {
    "pattern": "Auriga",
    "alpha": 3.375,
    "beta": 3.375,
    "gamma": 17.0859375
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 888,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 39
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 43
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 690
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 875,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 870,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 57,
    "gamma": 57
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 1.5000000000000002
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 51,
    "gamma": 41
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 54,
    "beta": 6,
    "gamma": 54
  },
  {
    "pattern": "Andromeda",
    "alpha": 341,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 13,
    "beta": 377,
    "gamma": -55
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 45,
    "beta": 6,
    "gamma": 91
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 866,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 60,
    "beta": 18,
    "gamma": 216
  },
  {
    "pattern": "Pisces",
    "alpha": -8,
    "beta": 8,
    "gamma": -34
  },
  {
    "pattern": "Andromeda",
    "alpha": 313,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 697
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 168,
    "gamma": 468
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 35
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 562,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Andromeda",
    "alpha": 344,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 858,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 517,
    "gamma": 819
  },
  {
    "pattern": "Auriga",
    "alpha": 3,
    "beta": 21,
    "gamma": -34
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 168,
    "gamma": 36
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 872,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Aquarius",
    "alpha": -5,
    "beta": 2,
    "gamma": -13
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": 8
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 57
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 18,
    "gamma": 330
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.1111111111111111,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 529,
    "gamma": 819
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.5,
    "gamma": 0.125
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 0.7
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 17
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 852,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 377,
    "beta": 144,
    "gamma": 377
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 847,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 834
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Pisces",
    "alpha": 5,
    "beta": 3,
    "gamma": 55
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.3333333333333333,
    "beta": 0.3333333333333333,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.03125,
    "gamma": 0.03125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 824,
    "beta": 578,
    "gamma": 855
  },
  {
    "pattern": "Pisces",
    "alpha": 3,
    "beta": 2,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.0625,
    "gamma": 0.0625
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 862,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 65,
    "beta": 15,
    "gamma": 111
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -8,
    "beta": 144,
    "gamma": -13
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 8,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 3.600000000000002
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 865,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 216,
    "gamma": 90
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 337,
    "gamma": 712
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 811,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 51
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.015625,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 823,
    "beta": 578,
    "gamma": 827
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 330,
    "beta": 168,
    "gamma": 468
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.125,
    "beta": 0.5,
    "gamma": 0.03125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.015625,
    "gamma": 0.5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 825,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 833,
    "beta": 578,
    "gamma": 832
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 15
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 35
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -5,
    "beta": 233,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 826,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03703703703703703,
    "beta": 0.012345679012345677,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 802,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 144,
    "gamma": -3
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0001524157902758725,
    "beta": 0.001371742112482853,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00390625,
    "beta": 0.03125,
    "gamma": 0.0078125
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 53,
    "gamma": 19
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 55,
    "gamma": -5
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.125,
    "gamma": 0.25
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 18,
    "gamma": 396
  },
  {
    "pattern": "Crux",
    "alpha": 1026,
    "beta": 330,
    "gamma": 720
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 2.1000000000000005
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -2,
    "beta": 89,
    "gamma": 8
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 47
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.1111111111111111,
    "gamma": 0.004115226337448558
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 828
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 273,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 36,
    "gamma": 468
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 629
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 45,
    "gamma": 31
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 59,
    "gamma": 63
  },
  {
    "pattern": "Lyra",
    "alpha": 1026,
    "beta": 126,
    "gamma": 216
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 64,
    "beta": 16,
    "gamma": 128
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 260,
    "beta": 34,
    "gamma": 369
  },
  {
    "pattern": "Pisces",
    "alpha": 2,
    "beta": 2,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 807,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 396,
    "beta": 90,
    "gamma": 330
  },
  {
    "pattern": "Auriga",
    "alpha": -6,
    "beta": 90,
    "gamma": -126
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 840,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Crux",
    "alpha": 1067,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 8,
    "beta": 2,
    "gamma": 32
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 245,
    "gamma": 610
  },
  {
    "pattern": "Andromeda",
    "alpha": 328,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 829,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 879,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 3,
    "gamma": 14
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 403.4287934927351,
    "beta": 148.4131591025766,
    "gamma": 403.4287934927351
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 816,
    "beta": 546,
    "gamma": 720
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Crux",
    "alpha": 720,
    "beta": 168,
    "gamma": 468
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.25,
    "gamma": 0.015625
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 630,
    "beta": 90,
    "gamma": 468
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 39,
    "gamma": 27
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -3,
    "beta": 144,
    "gamma": 13
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 57,
    "gamma": 27
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.00045724737082761756,
    "beta": 0.1111111111111111,
    "gamma": 0.1111111111111111
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 851,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Crux",
    "alpha": 918,
    "beta": 330,
    "gamma": 630
  },
  {
    "pattern": "Sculptor",
    "alpha": 377,
    "beta": 111,
    "gamma": 175
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 841,
    "beta": 578,
    "gamma": 806
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 51,
    "gamma": 27
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 53
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 45,
    "gamma": 33
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 886,
    "beta": 578,
    "gamma": 800
  },
  {
    "pattern": "Andromeda",
    "alpha": 284,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": 2,
    "beta": 233,
    "gamma": -13
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 584,
    "beta": 118,
    "gamma": 585
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 819,
    "beta": 118,
    "gamma": 585
  },
  {
    "pattern": "Auriga Seed",
    "alpha": 5,
    "beta": 55,
    "gamma": -21
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 20,
    "beta": 4,
    "gamma": 166
  },
  {
    "pattern": "Sagitta",
    "alpha": -5,
    "beta": 89,
    "gamma": 21
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 888,
    "beta": 578,
    "gamma": 801
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.2,
    "gamma": 3.4000000000000017
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 860,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.0078125,
    "beta": 0.5,
    "gamma": 0.0078125
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 232,
    "gamma": 610
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 126,
    "beta": 18,
    "gamma": 468
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.03125,
    "beta": 0.25,
    "gamma": 0.125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 883,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 830
  },
  {
    "pattern": "Aquarius",
    "alpha": 0,
    "beta": 3,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 806,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 825
  },
  {
    "pattern": "Aquarius",
    "alpha": -13,
    "beta": 8,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 887,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 67
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Auriga",
    "alpha": -2,
    "beta": 8,
    "gamma": -2
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0,
    "gamma": 1
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 55
  },
  {
    "pattern": "Pisces",
    "alpha": 25,
    "beta": 25,
    "gamma": 144
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -13,
    "beta": 377,
    "gamma": 89
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 815
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 21,
    "beta": 3,
    "gamma": 34
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 812
  },
  {
    "pattern": "Auriga Seed",
    "alpha": -8,
    "beta": 144,
    "gamma": -21
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 181,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 831,
    "beta": 578,
    "gamma": 854
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 5,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 855,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 63,
    "gamma": 37
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 819,
    "beta": 580,
    "gamma": 819
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 2,
    "gamma": 2
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 838,
    "beta": 578,
    "gamma": 835
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 820,
    "beta": 578,
    "gamma": 814
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 55,
    "gamma": 67
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 13
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 55,
    "gamma": 67
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 885,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 21,
    "gamma": 21
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 328,
    "gamma": 610
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 880,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 810
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 856,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.004115226337448558,
    "beta": 0.012345679012345677,
    "gamma": 0.012345679012345677
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 890,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 844,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.0078125,
    "beta": 0.00390625,
    "gamma": 0.5
  },
  {
    "pattern": "Sagitta",
    "alpha": -2,
    "beta": 34,
    "gamma": -3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 90,
    "beta": 36,
    "gamma": 270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 843
  },
  {
    "pattern": "Cygnus X2",
    "alpha": 168,
    "beta": 6,
    "gamma": 396
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 23
  },
  {
    "pattern": "Auriga",
    "alpha": -5,
    "beta": 21,
    "gamma": -34
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 61,
    "gamma": 53
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 64,
    "beta": 8,
    "gamma": 64
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 47,
    "gamma": 25
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.001371742112482853,
    "beta": 0.3333333333333333,
    "gamma": 0.3333333333333333
  },
  {
    "pattern": "Draco",
    "alpha": 16,
    "beta": 2,
    "gamma": 512
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 845,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 59,
    "gamma": 69
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 377,
    "gamma": -34
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 660
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 3,
    "gamma": -21
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -3,
    "beta": 233,
    "gamma": -21
  },
  {
    "pattern": "Lyra",
    "alpha": 2003,
    "beta": 49,
    "gamma": 43
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.1,
    "gamma": 0.8999999999999999
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 835,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 837,
    "beta": 578,
    "gamma": 838
  },
  {
    "pattern": "Aquarius",
    "alpha": -8,
    "beta": 2,
    "gamma": -13
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 848,
    "beta": 578,
    "gamma": 808
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 84,
    "beta": 39,
    "gamma": 258
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 0.4999999999999999,
    "gamma": 0.5000000000000001
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 808,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Auriga Galaxy",
    "alpha": -21,
    "beta": 233,
    "gamma": -3
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 168,
    "beta": 60,
    "gamma": 216
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 891,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 805
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 843,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 61,
    "gamma": 31
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.015625,
    "beta": 0.03125,
    "gamma": 0.125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 854,
    "beta": 578,
    "gamma": 837
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 90,
    "beta": 36,
    "gamma": 168
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 818,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 63
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 715,
    "beta": 214.49999999999997,
    "gamma": 715
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 90,
    "gamma": 270
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 823
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 830,
    "beta": 578,
    "gamma": 824
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 857,
    "beta": 578,
    "gamma": 811
  },
  {
    "pattern": "Aquarius",
    "alpha": -2,
    "beta": 2,
    "gamma": -8
  },
  {
    "pattern": "Andromeda",
    "alpha": 468,
    "beta": 330,
    "gamma": 720
  },
  {
    "pattern": "Lyra",
    "alpha": 1260,
    "beta": 126,
    "gamma": 168
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 842,
    "beta": 578,
    "gamma": 833
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 616
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 863,
    "beta": 578,
    "gamma": 817
  },
  {
    "pattern": "Lyra",
    "alpha": 1597,
    "beta": 144,
    "gamma": -233
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 669
  },
  {
    "pattern": "Pisces",
    "alpha": -13,
    "beta": 2,
    "gamma": -21
  },
  {
    "pattern": "Little Dipper",
    "alpha": 1,
    "beta": 0.5000000000000001,
    "gamma": 0
  },
  {
    "pattern": "Little Dipper",
    "alpha": 0.0078125,
    "beta": 0.0078125,
    "gamma": 0.125
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 874,
    "beta": 578,
    "gamma": 809
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 813,
    "beta": 578,
    "gamma": 807
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 861,
    "beta": 578,
    "gamma": 829
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 873,
    "beta": 578,
    "gamma": 820
  },
  {
    "pattern": "Crux",
    "alpha": 915,
    "beta": 233,
    "gamma": 610
  },
  {
    "pattern": "Aquarius",
    "alpha": 0,
    "beta": 3.8918202981106265,
    "gamma": 0
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 306.0196847852814,
    "beta": 9.869604401089358,
    "gamma": 306.0196847852814
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 834,
    "beta": 578,
    "gamma": 851
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 818
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 811,
    "beta": 578,
    "gamma": 821
  },
  {
    "pattern": "Auriga Galaxy",
    "alpha": -21,
    "beta": 233,
    "gamma": -2
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 41,
    "gamma": 19
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 188,
    "gamma": 610
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 337,
    "gamma": 646
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 320,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": -3,
    "beta": 2,
    "gamma": 5
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 822,
    "beta": 578,
    "gamma": 826
  },
  {
    "pattern": "Aquarius",
    "alpha": -36,
    "beta": 60,
    "gamma": -36
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 153,
    "beta": 28,
    "gamma": 153
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 324,
    "gamma": 610
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 227,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0,
    "beta": 0.5000000000000001,
    "gamma": 0
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 864,
    "beta": 578,
    "gamma": 819
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 813
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 827,
    "beta": 578,
    "gamma": 860
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 64,
    "beta": 2,
    "gamma": 64
  },
  {
    "pattern": "Gemini Galaxy",
    "alpha": -2,
    "beta": 1597,
    "gamma": -5
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 216,
    "beta": 36,
    "gamma": 468
  },
  {
    "pattern": "Cygnus X1",
    "alpha": 270,
    "beta": 90,
    "gamma": 270
  },
  {
    "pattern": "Cetus",
    "alpha": 1043,
    "beta": 280,
    "gamma": 610
  },
  {
    "pattern": "Big Dipper",
    "alpha": 0.25,
    "beta": 0.5,
    "gamma": 0.015625
  },
  {
    "pattern": "Auriga",
    "alpha": -3,
    "beta": 5,
    "gamma": 8
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 877,
    "beta": 578,
    "gamma": 802
  },
  {
    "pattern": "Aquarius",
    "alpha": -36,
    "beta": 60,
    "gamma": -90
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 828,
    "beta": 578,
    "gamma": 859
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 836,
    "beta": 578,
    "gamma": 836
  },
  {
    "pattern": "Crux",
    "alpha": 1043,
    "beta": 170,
    "gamma": 610
  },
  {
    "pattern": "Pisces",
    "alpha": 5,
    "beta": 5,
    "gamma": 55
  },
  {
    "pattern": "Scorpius",
    "alpha": 23.140692632779267,
    "beta": 2.453701991420671,
    "gamma": 23.140692632779267
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 884,
    "beta": 578,
    "gamma": 804
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 850,
    "beta": 578,
    "gamma": 816
  },
  {
    "pattern": "Lyra",
    "alpha": 2001,
    "beta": 49,
    "gamma": 55
  },
  {
    "pattern": "Cassiopeia",
    "alpha": 868,
    "beta": 578,
    "gamma": 800
  }
];